import EventEmitter from 'eventemitter3';
import { logDebug, createLoggerDecorator, EventTracking, frequencyControl } from '@xkit-yx/utils';
import NIM from '@yxim/nim-web-sdk/dist/SDK/NIM_Web_NIM';
import NIM$1 from 'nim-web-sdk-ng';
import * as nertcWebSdk from 'nertc-web-sdk';
export { nertcWebSdk as WebNertc };
import Chatroom from '@yxim/nim-web-sdk/dist/SDK/NIM_Web_Chatroom';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var name$2 = "@xkit-yx/core-kit";
var version$2 = "0.13.4";
var description$2 = "";
var main$2 = "dist/index.cjs.js";
var module = "dist/index.esm.js";
var unpkg = "dist/index.umd.js";
var typings = "dist/types/index.d.ts";
var miniprogram = "dist/miniprogram";
var files$2 = [
	"dist"
];
var publishConfig = {
	access: "public"
};
var scripts$2 = {
	dev: "rollup -c --environment DEV",
	build: "rollup -c --environment PROD"
};
var repository$1 = {
	type: "git",
	url: "ssh://git@g.hz.netease.com:22222/yunxin-app/kit-room-web.git"
};
var author$2 = "";
var license$1 = "MIT";
var peerDependencies = {
	"@xkit-yx/utils": "^0.4.3",
	"@yxim/nim-web-sdk": "9.14.4",
	axios: "^0.27.2",
	eventemitter3: "^4.0.7",
	"nertc-web-sdk": "5.5.30",
	"nim-web-sdk-ng": "0.17.0"
};
var dependencies = {
	"@xkit-yx/utils": "^0.6.0",
	"@yxim/nim-web-sdk": "9.14.4",
	axios: "^0.27.2",
	eventemitter3: "^4.0.7",
	"nertc-web-sdk": "5.5.30",
	"nim-web-sdk-ng": "0.17.0"
};
var devDependencies$2 = {
	"@rollup/plugin-alias": "^4.0.3",
	"@rollup/plugin-json": "^4.1.0",
	"@rollup/plugin-node-resolve": "^10.0.0",
	"@rollup/plugin-replace": "^4.0.0",
	"miniprogram-api-typings": "^3.4.6",
	rollup: "^2.33.1",
	"rollup-plugin-commonjs": "^10.1.0",
	"rollup-plugin-terser": "^7.0.2",
	"rollup-plugin-typescript2": "^0.31.2"
};
var gitHead = "eb40aeaba535412ca645513da5c39b00d91efda0";
var packageJson = {
	name: name$2,
	version: version$2,
	description: description$2,
	main: main$2,
	module: module,
	unpkg: unpkg,
	typings: typings,
	miniprogram: miniprogram,
	files: files$2,
	publishConfig: publishConfig,
	scripts: scripts$2,
	repository: repository$1,
	author: author$2,
	license: license$1,
	peerDependencies: peerDependencies,
	dependencies: dependencies,
	devDependencies: devDependencies$2,
	gitHead: gitHead
};

var name$1 = "@yxim/nim-web-sdk";
var version$1 = "9.14.4";
var sdkVersion = 91404;
var privateVersion = "7.9.0.0";
var stableVersion = "8.9.123";
var stableSdkVersion = 2323;
var protocolVersion = 1;
var description$1 = "NIM Web SDK 网易云信|真正稳定的即时通讯云服务";
var main$1 = "dist/SDK/NIM_Web_SDK.js";
var types$4 = "dist/types/index.d.ts";
var directories = {
	test: "test"
};
var scripts$1 = {
	prepare: "husky install",
	clean: "rm -rf ./dist",
	lint: "npx eslint ./src ./test",
	"build:sdk": "webpack --config webpack.config.js",
	"build:api": "jsdoc -r -c ./build/api/jsdoc.config.json -t ./external/ink-docstrap/template -d ./dist/api && npm run build:ts-api",
	"zip:api": "cross-env NODE_ENV=production npm run build:api && node build/api/zip.js",
	"zip:sdk": "cross-env NODE_ENV=production node build/sdk/zip.js",
	copy: "cross-env NODE_ENV=production node build/sdk/copy.js ",
	dev: "npm run clean && cross-env PLATFORM=all npm run build:sdk -- -w",
	stable: "npm run clean && cross-env PERMISSION=privatization PLATFORM=all npm run build:sdk -- -w",
	setStableVersion: "node setStableVersion.js",
	tsc: "tsc --emitDeclarationOnly",
	"analyzer:browser": "npm run clean && cross-env PLATFORM=browser NODE_ENV=production ANALYZER_BROWSER=true npm run build:sdk",
	"analyzer:miniapp": "npm run clean && cross-env PLATFORM=miniapp NODE_ENV=production ANALYZER_MINIAPP=true npm run build:sdk",
	pack: "npm run clean && cross-env PLATFORM=all NODE_ENV=production npm run build:sdk && npm run tsc && npm run zip:sdk && npm run copy",
	"pack:stable": "npm run clean && cross-env PLATFORM=all NODE_ENV=production PERMISSION=privatization npm run build:sdk && npm run tsc && npm run zip:sdk && npm run copy",
	test: "jest \"--runInBand\" --coverage --coverageReporters='html'",
	"build:ts-api": "typedoc --name NIM --tsconfig ./typedocNIM.json && typedoc --name Chatroom --tsconfig ./typedocChatroom.json"
};
var files$1 = [
	"dist/SDK/",
	"dist/types/"
];
var author$1 = "netease";
var devDependencies$1 = {
	"@babel/cli": "^7.16.0",
	"@babel/core": "^7.16.0",
	"@babel/plugin-transform-runtime": "^7.16.4",
	"@babel/preset-env": "^7.16.4",
	"@babel/runtime-corejs3": "^7.16.3",
	"@typescript-eslint/eslint-plugin": "^5.28.0",
	"@typescript-eslint/parser": "^5.28.0",
	"@yxfe/nim-log-reporter": "^0.1.24",
	"@yxfe/request": "^0.2.12",
	archiver: "^2.1.1",
	"aws-sdk": "^2.1039.0",
	axios: "^0.18.0",
	"babel-loader": "^8.2.3",
	"babel-plugin-add-module-exports": "^0.2.1",
	"babel-plugin-transform-async-to-generator": "^6.24.1",
	"babel-plugin-transform-runtime": "^6.23.0",
	backo2: "^1.0.2",
	"core-js": "^3.19.1",
	"cross-env": "^5.1.4",
	"crypto-js": "^4.1.1",
	"deep-access": "^0.1.1",
	dotenv: "^16.1.4",
	"es6-promise": "^4.2.4",
	eslint: "^8.9.0",
	"eslint-config-prettier": "^8.5.0",
	"eslint-plugin-prettier": "^4.0.0",
	eventemitter3: "^4.0.7",
	"fs-extra": "^5.0.0",
	happypack: "^5.0.1",
	husky: "^8.0.1",
	"imports-loader": "^0.8.0",
	"ink-docstrap": "^1.3.2",
	"javascript-natural-sort": "^0.7.1",
	"javascript-state-machine": "^3.1.0",
	jest: "^27.5.1",
	"js-conditional-compile-loader": "^1.0.15",
	jsdoc: "^3.6.0",
	lodash: "^4.17.21",
	md5: "^2.2.1",
	"npm-run-all": "^4.1.2",
	"object-assign": "^4.1.1",
	"on-build-webpack": "^0.1.0",
	"pre-build-webpack": "^0.1.0",
	prettier: "^2.7.1",
	prettyjson: "^1.1.3",
	prompt: "^1.0.0",
	"raw-loader": "^0.5.1",
	typedoc: "^0.22.11",
	typescript: "^4.5.4",
	"watch-cli": "^0.2.3",
	webpack: "^4.5.0",
	"webpack-bundle-analyzer": "^4.5.0",
	"webpack-cli": "^3.3.12",
	"webpack-merge": "^4.1.2",
	"wolfy87-eventemitter": "^5.2.4",
	"worker-loader": "^3.0.4",
	ws: "^5.1.1",
	x2js: "^3.2.1",
	xhr: "^2.4.1",
	yaml: "^0.3.0",
	yargs: "^11.0.0"
};
var imPackageJson$1 = {
	name: name$1,
	"private": false,
	version: version$1,
	sdkVersion: sdkVersion,
	privateVersion: privateVersion,
	stableVersion: stableVersion,
	stableSdkVersion: stableSdkVersion,
	protocolVersion: protocolVersion,
	description: description$1,
	main: main$1,
	types: types$4,
	directories: directories,
	scripts: scripts$1,
	files: files$1,
	author: author$1,
	devDependencies: devDependencies$1
};

/**
 * 合并默认函数和新传入的函数对象
 * @param originObjFunc
 * @param mergeObjFunc
 */
function mergeFuncObj(originObjFunc, mergeObjFunc) {
    var res = {};
    Object.keys(mergeObjFunc).forEach(function (funcName) {
        var originFunc = originObjFunc ? originObjFunc[funcName] : undefined;
        var hijackFunc = mergeObjFunc[funcName];
        if (originFunc) {
            // 拦截到的并且原始传了的，两者都执行
            res[funcName] = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                originFunc.apply(this, args);
                hijackFunc.apply(this, args);
            };
        }
        else {
            // 拦截到的但是原始没传的，取拦截到的
            res[funcName] = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                hijackFunc.apply(this, args);
            };
        }
    });
    return __assign(__assign({}, originObjFunc), res);
}
// 过滤掉对象中的 undefined
// 为什么不过滤 null，因为 null 也是有意义的
var filterEmptyKey = function (obj) {
    var res = __assign({}, obj);
    Object.keys(res).forEach(function (key) {
        if (res[key] === undefined) {
            delete res[key];
        }
    });
    return res;
};

var NIMWebSystemMessageType;
(function (NIMWebSystemMessageType) {
    NIMWebSystemMessageType[NIMWebSystemMessageType["addFriend"] = 0] = "addFriend";
    NIMWebSystemMessageType[NIMWebSystemMessageType["applyFriend"] = 1] = "applyFriend";
    NIMWebSystemMessageType[NIMWebSystemMessageType["applySuperTeam"] = 2] = "applySuperTeam";
    NIMWebSystemMessageType[NIMWebSystemMessageType["applyTeam"] = 3] = "applyTeam";
    NIMWebSystemMessageType[NIMWebSystemMessageType["custom"] = 4] = "custom";
    NIMWebSystemMessageType[NIMWebSystemMessageType["deleteFriend"] = 5] = "deleteFriend";
    NIMWebSystemMessageType[NIMWebSystemMessageType["deleteMsg"] = 6] = "deleteMsg";
    NIMWebSystemMessageType[NIMWebSystemMessageType["passFriendApply"] = 7] = "passFriendApply";
    NIMWebSystemMessageType[NIMWebSystemMessageType["rejectFriendApply"] = 8] = "rejectFriendApply";
    NIMWebSystemMessageType[NIMWebSystemMessageType["rejectSuperTeamApply"] = 9] = "rejectSuperTeamApply";
    NIMWebSystemMessageType[NIMWebSystemMessageType["rejectSuperTeamInvite"] = 10] = "rejectSuperTeamInvite";
    NIMWebSystemMessageType[NIMWebSystemMessageType["rejectTeamApply"] = 11] = "rejectTeamApply";
    NIMWebSystemMessageType[NIMWebSystemMessageType["rejectTeamInvite"] = 12] = "rejectTeamInvite";
    NIMWebSystemMessageType[NIMWebSystemMessageType["superTeamInvite"] = 13] = "superTeamInvite";
    NIMWebSystemMessageType[NIMWebSystemMessageType["teamInvite"] = 14] = "teamInvite";
})(NIMWebSystemMessageType || (NIMWebSystemMessageType = {}));
var logger$1 = logDebug({
    level: 'debug',
    appName: packageJson.name,
    version: packageJson.version,
});
var loggerDec$1 = createLoggerDecorator('nim-kit-core-1', logger$1);
var NimKitCore$1 = /** @class */ (function () {
    function NimKitCore(_a) {
        var initOptions = _a.initOptions, _b = _a.otherOptions, otherOptions = _b === void 0 ? {} : _b, _c = _a.funcOptions, funcOptions = _c === void 0 ? {} : _c, _d = _a.platform, platform = _d === void 0 ? 'Web' : _d;
        var _this = this;
        this.version = imPackageJson$1.version;
        this.connectState = 'idle';
        this.emitter = new EventEmitter();
        this.initOptions = initOptions;
        this.otherOptions = otherOptions;
        this.platform = platform;
        var hijackFuncs = {
            onconnect: function (params) {
                _this.emit('logined', params);
                _this.connectState = 'connected';
            },
            ondisconnect: function (error) {
                _this.connectState = 'disconnected';
                if (error) {
                    switch (error.code) {
                        // 账号或者密码错误, 请跳转到登录页面并提示错误
                        case 302:
                            _this.emit('disconnect');
                            break;
                        // 重复登录, 已经在其它端登录了, 请跳转到登录页面并提示错误
                        case 417:
                            _this.emit('disconnect');
                            break;
                        // 被踢, 请提示错误后跳转到登录页面
                        case 'kicked':
                            _this.emit('kicked', error);
                            break;
                        default:
                            _this.emit('disconnect');
                            break;
                    }
                }
                else {
                    _this.emit('disconnect');
                }
            },
            onwillreconnect: function (params) {
                _this.connectState = 'connecting';
                _this.emit('willReconnect', params);
            },
            onProxyMsg: function (params) {
                _this.emit('proxyMsg', params);
            },
            // 这边可能要对数据进行处理，输出符合 im2 定义的数据
            onmsg: function (params) {
                var msg = _this._formatMsg1to2(params);
                _this.emit('msg', msg);
            },
            onStickTopSessions: function (params) {
                var sessions = params
                    .map(function (item) { return _this._formatSession1to2(item); })
                    .map(function (item) { return (__assign(__assign({}, item), { lastMsg: item.lastMsg || null, updateTime: item.updateTeam || 0 })); });
                _this.emit('sessions', sessions);
            },
            onsessions: function (params) {
                var sessions = params.map(function (item) { return _this._formatSession1to2(item); });
                _this.emit('sessions', sessions);
            },
            onupdatesession: function (params) {
                var session = _this._formatSession1to2(params);
                _this.emit('updateSession', session);
            },
            onAddTeamMembers: function (params) {
                _this.emit('addTeamMembers', __assign(__assign({}, params), { team: _this._formatTeam1to2(params.team), members: params.members.map(_this._formatTeamMember1to2.bind(_this)) }));
            },
            onRemoveTeamMembers: function (params) {
                _this.emit('removeTeamMembers', __assign(__assign({}, params), { team: _this._formatTeam1to2(params.team) }));
            },
            onupdateteammember: function (params) {
                _this.emit('updateTeamMember', _this._formatTeamMember1to2(params));
            },
            onUpdateTeamManagers: function (params) {
                _this.emit('updateTeamManagers', __assign(__assign({}, params), { team: _this._formatTeam1to2(params.team), members: params.members
                        .map(_this._formatTeamMember1to2.bind(_this))
                        .map(function (item) { return (__assign(__assign({}, item), { 
                        // sdk 返回的 member 没有 account，手动处理下
                        account: item.id.split(params.team.teamId + '-')[1] })); }) }));
            },
            onUpdateTeamMembersMute: function (params) {
                _this.emit('updateTeamMembersMute', __assign(__assign({}, params), { team: _this._formatTeam1to2(params.team), members: params.members.map(_this._formatTeamMember1to2.bind(_this)) }));
            },
            onteams: function (params) {
                _this.emit('teams', params.map(_this._formatTeam1to2.bind(_this)));
            },
            onsynccreateteam: function (params) {
                _this.emit('createTeam', _this._formatTeam1to2(params), {});
            },
            onCreateTeam: function (params) {
                _this.emit('createTeam', _this._formatTeam1to2(params), {});
            },
            onDismissTeam: function (params) {
                _this.emit('dismissTeam', params);
            },
            onUpdateTeam: function (params) {
                _this.emit('updateTeam', _this._formatTeam1to2(params));
            },
            onTransferTeam: function (params) {
                _this.emit('transferTeam', __assign(__assign({}, params), { team: _this._formatTeam1to2(params.team) }));
            },
            onsyncfriendaction: function (_a) {
                var account = _a.account, friend = _a.friend, type = _a.type;
                _this.emit('syncFriend', {
                    account: account,
                    friend: friend,
                    type: type,
                });
            },
            onfriends: function (data) {
                _this.emit('friends', data);
            },
            onDeleteMsgSelf: function (msgs) {
                var newMsgs = msgs.map(function (item) { return _this._formatMsg1to2(item); });
                _this.emit('deleteSelfMsgs', newMsgs);
            },
            onblacklist: function (data) {
                _this.emit('relations', { blackList: data, muteList: [] });
            },
            onsyncmarkinblacklist: function (data) {
                _this.emit('updateBlackList', data);
            },
            onmutelist: function (data) {
                _this.emit('relations', { blackList: [], muteList: data });
            },
            onsyncmarkinmutelist: function (data) {
                _this.emit('updateMuteList', data);
            },
            onusers: function (data) {
                _this.emit('users', data);
            },
            onmyinfo: function (data) {
                _this.emit('syncMyNameCard', data);
            },
            onupdatemyinfo: function (params) {
                _this.emit('updateMyNameCard', __assign(__assign({}, params), { signature: params.sign, ext: params.custom }));
            },
            onsysmsg: function (data) {
                _this.emit('sysMsg', _this._formatSysMsg1to2(data));
            },
            onofflinesysmsgs: function (data) {
                var sysMsgs = data.map(_this._formatSysMsg1to2);
                _this.emit('syncSysMsgs', sysMsgs);
            },
            onroamingsysmsgs: function (data) {
                var sysMsgs = data.map(_this._formatSysMsg1to2);
                _this.emit('syncSysMsgs', sysMsgs);
            },
            onupdatesysmsg: function (data) {
                var sysMsg = _this._formatSysMsg1to2(data);
                _this.emit('updateSystemMessages', [
                    {
                        idServer: sysMsg.idServer,
                        state: 
                        // @ts-ignore
                        sysMsg.state === 'passed'
                            ? 'pass'
                            : // @ts-ignore
                                sysMsg.state === 'rejected'
                                    ? 'decline'
                                    : 'invalid',
                        from: sysMsg.from,
                        type: sysMsg.type,
                    },
                ]);
            },
            onTeamMsgReceipt: function (data) {
                _this.emit('teamMsgReceipts', data.teamMsgReceipts);
            },
            onpushevents: function (data) {
                _this.emit('pushEvents', data.msgEvents.map(function (item) { return (__assign(__assign({}, item), { ext: item.custom, clientType: item.clientType, type: Number(item.type), value: Number(item.value), time: Number(item.time) })); }));
            },
            onsyncdone: function () {
                _this.emit('syncdone');
            },
            onloginportschange: function (data) {
                _this.emit('multiPortLogin', data);
            },
        };
        var finalFuncOptions = this._hijackFunc(funcOptions, hijackFuncs);
        this.nim = NIM.getInstance(__assign(__assign(__assign({}, initOptions), { appKey: initOptions.appkey, account: initOptions.account, token: initOptions.token, debug: initOptions.debugLevel !== 'off', 
            // @ts-ignore
            privateConf: otherOptions.serverConfig, 
            // 是否开启 db
            db: false, 
            // 忽略通知类消息
            shouldIgnoreNotification: function () { return false; }, shouldCountNotifyUnread: function () { return false; }, 
            // 同步未读数
            syncSessionUnread: true, rollbackDelMsgUnread: true, rollbackClearMsgsUnread: true, syncStickTopSessions: true }), finalFuncOptions));
        // 埋点上报
        var reportComponents = [
            'ContactKit',
            'ConversationKit',
            'ChatKit',
            'SearchKit',
        ];
        reportComponents.forEach(function (item) {
            var eventTracking = new EventTracking({
                appKey: _this.initOptions.appkey,
                version: '9.3.1',
                component: item,
                imVersion: _this.version,
                platform: _this.platform,
            });
            eventTracking.track('init', '');
        });
        // this._getTeams = frequencyControl(this._getTeams, 1000)
        // this._getMuteList = frequencyControl(this._getMuteList, 1000)
        // this._getBlackList = frequencyControl(this._getBlackList, 1000)
        // this._getFriends = frequencyControl(this._getFriends, 1000)
    }
    NimKitCore.prototype.getNIM = function () {
        return this.nim;
    };
    NimKitCore.prototype.connect = function () {
        return this._connect();
    };
    NimKitCore.prototype.disconnect = function () {
        return this._disconnect();
    };
    NimKitCore.prototype.destroy = function () {
        return this._destroy();
    };
    // @loggerDec
    // public async getSessionList(
    //   options: GetSessionsOptions
    // ): Promise<ISession[]> {
    //   const [sessions, muteList, teams] = await Promise.all([
    //     this._getSessions(options),
    //     this._getMuteList(),
    //     this._getTeams(),
    //   ])
    //   const p2pAccids = sessions
    //     .filter((item) => item.scene === 'p2p')
    //     .map((item) => item.to)
    //   const userCards = await this._getUsersNameCardFromServer({
    //     accounts: p2pAccids,
    //   })
    //   return sessions.map((session) => {
    //     if (session.scene === 'p2p') {
    //       const card = userCards.find((item) => item.account === session.to)!
    //       const isMute = muteList.some((item) => item.account === session.to)
    //       return {
    //         ...session,
    //         ...card,
    //         isMute,
    //         // 这里以session的updateTime为准
    //         updateTime: session.updateTime,
    //       }
    //     } else {
    //       const team = teams.find((item) => item.teamId === session.to)
    //       return {
    //         ...session,
    //         ...team,
    //         // 这里以session的updateTime为准
    //         updateTime: session.updateTime,
    //       } as TeamSession
    //     }
    //   })
    // }
    // @loggerDec
    // public async getSession(params: SessionIdOptions): Promise<ISession> {
    //   const session = await this._getSession(params)
    //   if (!session) {
    //     throw Error('session 不存在')
    //   }
    //   if (session.scene === 'p2p') {
    //     const [userInfos, muteList] = await Promise.all([
    //       this._getUsersNameCardFromServer({
    //         accounts: [session.to],
    //       }),
    //       this._getMuteList(),
    //     ])
    //     const isMute = muteList.some((item) => item.account === session.to)
    //     return {
    //       ...session,
    //       ...userInfos[0],
    //       isMute,
    //       updateTime: session.updateTime,
    //     }
    //   } else {
    //     const teams = await this._getTeams()
    //     const team = teams.find((item) => item.teamId === session.to)!
    //     return {
    //       ...session,
    //       ...team,
    //       updateTime: session.updateTime,
    //     }
    //   }
    // }
    NimKitCore.prototype.saveMyUserInfo = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var uploadResult, error_1, updateParams, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(params.file && params.type)) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._uploadFile({
                                file: params.file,
                                type: params.type,
                            })];
                    case 2:
                        uploadResult = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        logger$1.error('uploadFile error: ', error_1);
                        logger$1.warn('去除头像信息继续保存用户信息');
                        return [3 /*break*/, 4];
                    case 4:
                        updateParams = {
                            nick: params.nick,
                            signature: params.signature,
                            avatar: uploadResult ? uploadResult.url : params.avatar,
                            gender: params.gender,
                            email: params.email,
                            birth: params.birth,
                            tel: params.tel,
                            ext: params.ext,
                        };
                        return [4 /*yield*/, this._updateMyNameCard(updateParams)];
                    case 5:
                        res = _a.sent();
                        return [2 /*return*/, res];
                }
            });
        });
    };
    // @loggerDec
    // public async getBlackList(): Promise<IBlackInfo[]> {
    //   const blackList = await this._getBlackList()
    //   const userCards = await this._getUsersNameCardFromServer({
    //     accounts: blackList.map((item) => item.account),
    //   })
    //   return blackList.map((black) => {
    //     const card = userCards.find((item) => item.account === black.account)
    //     return {
    //       ...black,
    //       ...card,
    //     }
    //   })
    // }
    // @loggerDec
    // public async getFriendList(): Promise<IFriendInfo[]> {
    //   const friendList = await this._getFriends()
    //   const userCards = await this._getUsersNameCardFromServer({
    //     accounts: friendList.map((item) => item.account),
    //   })
    //   return friendList.map((friend) => {
    //     const card = userCards.find((item) => item.account === friend.account)
    //     return {
    //       ...friend,
    //       ...card,
    //     }
    //   })
    // }
    // @loggerDec
    // public async getBlackInfos(options: {
    //   accounts: string[]
    // }): Promise<IBlackInfo[]> {
    //   return (await this.getBlackList()).filter((item) =>
    //     options.accounts.includes(item.account)
    //   )
    // }
    // @loggerDec
    // public async getFriendInfos(options: {
    //   accounts: string[]
    // }): Promise<IFriendInfo[]> {
    //   return (await this.getFriendList()).filter((item) =>
    //     options.accounts.includes(item.account)
    //   )
    // }
    NimKitCore.prototype.getMsgsByIdServer = function (params) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.nim.getMsgsByIdServer(__assign(__assign({}, params), { done: function (err, data) {
                    if (err) {
                        return reject(err);
                    }
                    resolve(data.msgs.map(_this._formatMsg1to2.bind(_this)));
                } }));
        });
    };
    NimKitCore.prototype.getTeamMembers = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this._getTeamMembers(params)];
            });
        });
    };
    NimKitCore.prototype.isSessionExist = function (sessionId) {
        return __awaiter(this, void 0, void 0, function () {
            var session;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._getSession({
                            id: sessionId,
                        })];
                    case 1:
                        session = _a.sent();
                        return [2 /*return*/, !!session && session.lastMsg !== void 0];
                }
            });
        });
    };
    NimKitCore.prototype.resetSessionUnreadCount = function (options) {
        return this._resetSessionUnreadCount(options);
    };
    NimKitCore.prototype.addFriend = function (options) {
        return this._addFriend(options);
    };
    NimKitCore.prototype.applyFriend = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.nim.applyFriend(__assign(__assign({}, options), { done: function (err) {
                                if (err) {
                                    return reject(err);
                                }
                                resolve();
                            } }));
                    })];
            });
        });
    };
    NimKitCore.prototype.deleteFriend = function (options) {
        return this._deleteFriend(options);
    };
    NimKitCore.prototype.updateFriend = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.nim.updateFriend(__assign(__assign({}, options), { custom: options.ext, done: function (err, obj) {
                                if (err) {
                                    return reject(err);
                                }
                                resolve();
                            } }));
                    })];
            });
        });
    };
    NimKitCore.prototype.setBlack = function (options) {
        return this._setBlack(options);
    };
    NimKitCore.prototype.deleteSession = function (options) {
        return this._deleteSession(options);
    };
    NimKitCore.prototype.setMute = function (options) {
        return this._setMute(options);
    };
    // @loggerDec
    // public getTeams(): Promise<Team[]> {
    //   return this._getTeams()
    // }
    NimKitCore.prototype.createTeam = function (options) {
        return this._createTeam(options);
    };
    NimKitCore.prototype.getUsersNameCardFromServer = function (options) {
        return this._getUsersNameCardFromServer(options);
    };
    NimKitCore.prototype.getTeamInfo = function (options) {
        return this._getTeamInfo(options);
    };
    NimKitCore.prototype.applyTeam = function (options) {
        return this._applyTeam(options);
    };
    // @loggerDec
    // public getFriends(): Promise<FriendProfile[]> {
    //   return this._getFriends()
    // }
    // @loggerDec
    // public async getBlacks(): Promise<MarkedUserInfo[]> {
    //   return this._getBlackList()
    // }
    NimKitCore.prototype.addTeamMembers = function (options) {
        return this._addTeamMembers(options);
    };
    NimKitCore.prototype.removeTeamMembers = function (options) {
        return this._removeTeamMembers(options);
    };
    NimKitCore.prototype.updateTeamInfo = function (options) {
        return this._updateTeamInfo(options);
    };
    NimKitCore.prototype.muteTeam = function (options) {
        return this._muteTeam(options);
    };
    NimKitCore.prototype.dismissTeam = function (options) {
        return this._dismissTeam(options);
    };
    NimKitCore.prototype.transferTeam = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            return _this.nim.transferTeam(__assign(__assign({}, options), { done: function (error) {
                    if (error) {
                        return reject(error);
                    }
                    resolve();
                } }));
        });
    };
    NimKitCore.prototype.leaveTeam = function (options) {
        return this._leaveTeam(options);
    };
    NimKitCore.prototype.sendTextMsg = function (options) {
        return this._sendTextMsg(__assign(__assign({}, options), { resend: false }));
    };
    NimKitCore.prototype.sendCustomMsg = function (options) {
        return this._sendCustomMsg(__assign(__assign({}, options), { resend: false }));
    };
    NimKitCore.prototype.sendImageMsg = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._sendFileMsg(__assign(__assign({}, options), { resend: false, type: 'image' }))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    NimKitCore.prototype.sendFileMsg = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._sendFileMsg(__assign(__assign({}, options), { resend: false, type: 'file' }))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    NimKitCore.prototype.sendVideoMsg = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._sendFileMsg(__assign(__assign({}, options), { resend: false, type: 'video' }))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    NimKitCore.prototype.sendAudioMsg = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this._sendFileMsg(__assign(__assign({}, options), { resend: false, type: 'audio' }))];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    // @loggerDec
    // public sendTipMsg(options: ISendTipMsgOptions): Promise<IMMessage> {
    //   return this.nim.sendTipMsg(options)
    // }
    NimKitCore.prototype.resendMsg = function (_a) {
        var msg = _a.msg;
        return __awaiter(this, void 0, void 0, function () {
            var newAttach;
            return __generator(this, function (_b) {
                newAttach = JSON.stringify(msg.attach);
                switch (msg.type) {
                    case 'text':
                        return [2 /*return*/, this._sendTextMsg(__assign(__assign({}, msg), { 
                                // @ts-ignore
                                status: this._formatMsgStatus2to1(msg.status), attach: newAttach, resend: true }))];
                    case 'file':
                        // @ts-ignore
                        return [2 /*return*/, this._sendFileMsg(__assign(__assign({}, msg), { 
                                // @ts-ignore
                                status: this._formatMsgStatus2to1(msg.status), resend: true, type: 'file' }))];
                    case 'image':
                        // @ts-ignore
                        return [2 /*return*/, this._sendFileMsg(__assign(__assign({}, msg), { 
                                // @ts-ignore
                                status: this._formatMsgStatus2to1(msg.status), resend: true, type: 'image' }))];
                    case 'audio':
                        // @ts-ignore
                        return [2 /*return*/, this._sendFileMsg(__assign(__assign({}, msg), { 
                                // @ts-ignore
                                status: this._formatMsgStatus2to1(msg.status), resend: true, type: 'audio' }))];
                    case 'video':
                        // @ts-ignore
                        return [2 /*return*/, this._sendFileMsg(__assign(__assign({}, msg), { 
                                // @ts-ignore
                                status: this._formatMsgStatus2to1(msg.status), resend: true, type: 'video' }))];
                    case 'custom':
                        return [2 /*return*/, this._sendCustomMsg(__assign(__assign({}, msg), { 
                                // @ts-ignore
                                status: this._formatMsgStatus2to1(msg.status), attach: newAttach, resend: true }))];
                    default:
                        throw Error('resendMsg type is not supported.');
                }
            });
        });
    };
    NimKitCore.prototype.recallMsg = function (options) {
        return this._recallMsg(options);
    };
    NimKitCore.prototype.sendMsgReceipt = function (options) {
        return this._sendMsgReceipt(options);
    };
    NimKitCore.prototype.sendTeamMsgReceipt = function (options) {
        return this._sendTeamMsgReceipt(options);
    };
    NimKitCore.prototype.clearHistoryMsgsFromServer = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.nim.clearServerHistoryMsgsWithSync(__assign(__assign({}, options), { done: function (err) {
                    if (err) {
                        return reject(err);
                    }
                    resolve();
                } }));
        });
    };
    NimKitCore.prototype.getTeamMsgReads = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.nim.getTeamMsgReads(__assign(__assign({}, options), { done: function (err, data, obj) {
                                if (err) {
                                    return reject(err);
                                }
                                resolve(obj.teamMsgReceipts);
                            } }));
                    })];
            });
        });
    };
    NimKitCore.prototype.deleteSelfMsgs = function (options) {
        return this._deleteSelfMsgs(options);
    };
    NimKitCore.prototype.getHistoryMsgs = function (options) {
        return this._getHistoryMsgs(options);
    };
    NimKitCore.prototype.passFriendApply = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.nim.passFriendApply(__assign(__assign({ 
                // @ts-ignore
                idServer: (Math.random() + '').slice(-6) }, options), { done: function (err, obj) {
                    if (err) {
                        return reject(err);
                    }
                    resolve();
                } }));
        });
    };
    NimKitCore.prototype.rejectFriendApply = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.nim.rejectFriendApply(__assign(__assign({ 
                // @ts-ignore
                idServer: (Math.random() + '').slice(-6) }, options), { done: function (err, obj) {
                    if (err) {
                        return reject(err);
                    }
                    resolve();
                } }));
        });
    };
    NimKitCore.prototype.passTeamApply = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.nim.passTeamApply(__assign(__assign({ idServer: (Math.random() + '').slice(-6) }, options), { done: function (err, obj) {
                    if (err) {
                        return reject(err);
                    }
                    resolve();
                } }));
        });
    };
    NimKitCore.prototype.rejectTeamApply = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.nim.rejectTeamApply(__assign(__assign({ idServer: (Math.random() + '').slice(-6) }, options), { done: function (err, obj) {
                    if (err) {
                        return reject(err);
                    }
                    resolve();
                } }));
        });
    };
    NimKitCore.prototype.acceptTeamInvite = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.nim.acceptTeamInvite(__assign(__assign({ idServer: (Math.random() + '').slice(-6) }, options), { done: function (err, obj) {
                    if (err) {
                        return reject(err);
                    }
                    resolve();
                } }));
        });
    };
    NimKitCore.prototype.rejectTeamInvite = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.nim.rejectTeamInvite(__assign(__assign({ idServer: (Math.random() + '').slice(-6) }, options), { done: function (err, obj) {
                    if (err) {
                        return reject(err);
                    }
                    resolve();
                } }));
        });
    };
    NimKitCore.prototype.addStickTopSession = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.nim.addStickTopSession({
                id: options.id,
                topCustom: options.ext,
                done: function (err, obj) {
                    if (err) {
                        return reject(err);
                    }
                    var session = _this._formatSession1to2(obj.stickTopSession);
                    resolve(session);
                },
            });
        });
    };
    NimKitCore.prototype.deleteStickTopSession = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.nim.deleteStickTopSession({
                id: options.id,
                done: function (err, obj) {
                    if (err) {
                        return reject(err);
                    }
                    var session = _this._formatSession1to2(obj.stickTopSession);
                    resolve(session);
                },
            });
        });
    };
    NimKitCore.prototype.updateMyMemberInfo = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.nim.updateInfoInTeam(__assign(__assign({}, options), { muteNotiType: options.bitConfigMask
                    ? options.bitConfigMask + ''
                    : undefined, custom: options.ext, done: function (err, obj) {
                    if (err) {
                        return reject(err);
                    }
                    resolve(_this._formatTeamMember1to2(obj));
                } }));
        });
    };
    NimKitCore.prototype.addTeamManagers = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.nim.addTeamManagers(__assign(__assign({}, options), { done: function (err) {
                    if (err) {
                        return reject(err);
                    }
                    resolve();
                } }));
        });
    };
    NimKitCore.prototype.removeTeamManagers = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.nim.removeTeamManagers(__assign(__assign({}, options), { done: function (err) {
                    if (err) {
                        return reject(err);
                    }
                    resolve();
                } }));
        });
    };
    NimKitCore.prototype.forwardMsg = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.nim.forwardMsg(__assign(__assign({}, options), { msg: _this._formatMsg2to1(options.msg), done: function (err, obj) {
                                if (err) {
                                    return reject(err);
                                }
                                resolve(_this._formatMsg1to2(obj));
                            } }));
                    })];
            });
        });
    };
    NimKitCore.prototype.subscribeEvent = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this.nim.subscribeEvent(__assign(__assign({}, options), { done: function (err) {
                                if (err) {
                                    return reject(err);
                                }
                                resolve();
                            } }));
                    })];
            });
        });
    };
    NimKitCore.prototype.on = function (eventName, fn, context) {
        this.emitter.on(eventName, fn, context);
        return this;
    };
    NimKitCore.prototype.off = function (eventName, fn, context, once) {
        this.emitter.off(eventName, fn, context, once);
        return this;
    };
    NimKitCore.prototype.emit = function (event) {
        var _a;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return (_a = this.emitter).emit.apply(_a, __spreadArray([event], __read(args), false));
    };
    NimKitCore.prototype._hijackFunc = function (originFuncs, hijackFuncs) {
        var res = {};
        Object.keys(hijackFuncs).forEach(function (funcName) {
            var originFunc = originFuncs[funcName];
            var hijackFunc = hijackFuncs[funcName];
            if (originFunc) {
                res[funcName] = function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    originFunc.apply(this, args);
                    hijackFunc.apply(this, args);
                };
            }
            else {
                res[funcName] = function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    hijackFunc.apply(this, args);
                };
            }
        });
        // 没拦截到的取原始的
        // 拦截到的但是原始没传的，取拦截到的
        // 拦截到的并且原始传了的，两者都执行
        return __assign(__assign({}, originFuncs), res);
    };
    NimKitCore.prototype._updateMyNameCard = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.nim.updateMyInfo(__assign(__assign({}, options), { sign: options.signature, custom: options.ext, done: function (error, obj) {
                    if (error) {
                        reject(error);
                    }
                    else {
                        resolve(obj);
                    }
                } }));
        });
    };
    NimKitCore.prototype._getRelations = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.nim.getRelations({
                done: function (err, obj) {
                    if (err) {
                        reject(err);
                    }
                    else {
                        resolve(obj);
                    }
                },
            });
        });
    };
    NimKitCore.prototype._getTeamMembers = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.nim.getTeamMembers(__assign(__assign({}, options), { done: function (err, obj) {
                    if (err) {
                        reject(err);
                    }
                    else {
                        resolve((obj.members || []).map(_this._formatTeamMember1to2.bind(_this)));
                    }
                } }));
        });
    };
    // private _getTeams(): Promise<Team[]> {
    //   return new Promise((resolve, reject) => {
    //     this.nim.getTeams({
    //       done: (error, teams) => {
    //         if (error) {
    //           // 忽略 803 错误，具体原因咨询 sdk
    //           if (error?.code === 803) {
    //             resolve([])
    //           } else {
    //             reject(error)
    //           }
    //         } else {
    //           const _teams: Team[] = teams.map(this._formatTeam1to2.bind(this))
    //           resolve(_teams)
    //         }
    //       },
    //     })
    //   })
    // }
    // private _getSessions(options: GetSessionsOptions): Promise<Session[]> {
    //   return new Promise((resolve, reject) => {
    //     this.nim.getLocalSessions({
    //       ...options,
    //       done: (err: any, obj: any) => {
    //         if (err) {
    //           reject(err)
    //         } else {
    //           const sessions = (obj.sessions || []).map((item) =>
    //             this._formatSession1to2(item)
    //           )
    //           resolve(sessions)
    //         }
    //       },
    //     })
    //   })
    // }
    NimKitCore.prototype._getSession = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.nim.getLocalSession({
                sessionId: options.id,
                done: function (err, obj) {
                    if (err) {
                        reject(err);
                    }
                    else {
                        var session = obj ? _this._formatSession1to2(obj) : obj;
                        resolve(session);
                    }
                },
            });
        });
    };
    // private async _getMuteList(): Promise<MarkedUserInfo[]> {
    //   const { mutelist } = await this._getRelations()
    //   return mutelist
    // }
    // private async _getBlackList(): Promise<MarkedUserInfo[]> {
    //   const { blacklist } = await this._getRelations()
    //   return blacklist
    // }
    // private _getFriends(): Promise<FriendProfile[]> {
    //   return new Promise((resolve, reject) => {
    //     this.nim.getFriends({
    //       done: (error, friends) => {
    //         if (error) {
    //           reject(error)
    //         } else {
    //           const _friends: FriendProfile[] = friends.map((friend) => {
    //             return {
    //               ...friend,
    //               ext: friend.custom,
    //             }
    //           })
    //           resolve(_friends)
    //         }
    //       },
    //     })
    //   })
    // }
    NimKitCore.prototype._uploadFile = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.nim.previewFile(__assign(__assign({}, options), { blob: options.file, uploaddone: function () {
                    //
                }, done: function (err, file) {
                    if (err) {
                        reject(err);
                    }
                    else {
                        resolve(file);
                    }
                } }));
        });
    };
    NimKitCore.prototype._getUsersNameCardFromServer = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        if (!options.accounts || !options.accounts.length) {
                            return resolve([]);
                        }
                        _this.nim.getUsers(__assign(__assign({}, options), { done: function (error, users) {
                                if (error) {
                                    reject(error);
                                }
                                else {
                                    var _users = users.map(function (user) {
                                        return __assign(__assign({}, user), { ext: user.custom, signature: user.sign });
                                    });
                                    resolve(_users);
                                }
                            } }));
                    })];
            });
        });
    };
    NimKitCore.prototype._formatSysMsg1to2 = function (data) {
        switch (data.type) {
            case 'addFriend':
                return __assign(__assign({}, data), { feature: 'default', idServer: data.idServer || '', type: 'friendRequest', attach: __assign(__assign({}, data.attach), { type: 'addFriend' }) });
            case 'applyFriend':
                return __assign(__assign({}, data), { feature: 'default', idServer: data.idServer || '', type: 'friendRequest', attach: __assign(__assign({}, data.attach), { type: 'applyFriend' }) });
            case 'applySuperTeam':
                return __assign(__assign({}, data), { feature: 'default', idServer: data.idServer || '', type: 'applySuperTeam' });
            case 'applyTeam':
                return __assign(__assign({}, data), { feature: 'default', idServer: data.idServer || '', type: 'applyTeam' });
            case 'custom':
                return __assign(__assign({}, data), { feature: 'default', idServer: data.idServer || '', type: data.scene === 'p2p'
                        ? 'customP2p'
                        : data.scene === 'team'
                            ? 'customTeam'
                            : 'customSuperTeam' });
            case 'deleteFriend':
                return __assign(__assign({}, data), { feature: 'default', idServer: data.idServer || '', type: 'deleteFriend' });
            case 'deleteMsg':
                return __assign(__assign({}, data), { feature: 'default', idServer: data.idServer || '', 
                    // @ts-ignore
                    recallMessageInfo: (data === null || data === void 0 ? void 0 : data.msg) || {}, type: data.scene === 'p2p'
                        ? 'recallMsgP2p'
                        : data.scene === 'team'
                            ? 'recallMsgTeam'
                            : 'recallMsgSuperTeam' });
            case 'passFriendApply':
                return __assign(__assign({}, data), { feature: 'default', idServer: data.idServer || '', type: 'friendRequest', attach: __assign(__assign({}, data.attach), { type: 'passFriendApply' }) });
            case 'rejectFriendApply':
                return __assign(__assign({}, data), { feature: 'default', idServer: data.idServer || '', type: 'friendRequest', attach: __assign(__assign({}, data.attach), { type: 'rejectFriendApply' }) });
            case 'rejectSuperTeamApply':
                return __assign(__assign({}, data), { feature: 'default', idServer: data.idServer || '', type: 'rejectSuperTeamApply' });
            case 'rejectSuperTeamInvite':
                return __assign(__assign({}, data), { feature: 'default', idServer: data.idServer || '', type: 'rejectSuperTeamInvite' });
            case 'rejectTeamApply':
                return __assign(__assign({}, data), { feature: 'default', idServer: data.idServer || '', type: 'rejectTeamApply' });
            case 'rejectTeamInvite':
                return __assign(__assign({}, data), { feature: 'default', idServer: data.idServer || '', type: 'rejectTeamInvite' });
            case 'superTeamInvite':
                return __assign(__assign({}, data), { feature: 'default', idServer: data.idServer || '', type: 'superTeamInvite' });
            case 'teamInvite':
                return __assign(__assign({}, data), { feature: 'default', idServer: data.idServer || '', type: 'teamInvite' });
            default:
                return __assign(__assign({}, data), { feature: 'default', idServer: data.idServer || '', type: '' });
        }
    };
    NimKitCore.prototype._formatMsgStatus1to2 = function (status, isInBlackList) {
        var statusMap = {
            sending: 'sending',
            success: 'sent',
            fail: 'sendFailed',
        };
        // @ts-ignore
        return isInBlackList ? 'refused' : statusMap[status] || status;
    };
    NimKitCore.prototype._formatMsgStatus2to1 = function (status) {
        var statusMap = {
            sending: 'sending',
            sent: 'success',
            sendFailed: 'fail',
        };
        return status === 'refused' ? 'fail' : statusMap[status] || status;
    };
    NimKitCore.prototype._formatSession1to2 = function (session) {
        return __assign(__assign({}, session), { stickTopInfo: {
                id: session.id,
                isStickOnTop: !!session.isTop,
                ext: session.topCustom,
            }, lastMsg: session.lastMsg
                ? this._formatMsg1to2(session.lastMsg)
                : session.lastMsg });
    };
    NimKitCore.prototype._formatMsg1to2 = function (msg) {
        var _a;
        var status = this._formatMsgStatus1to2(msg.status, msg.isInBlackList);
        var pushInfo = this._formatPushInfo1to2(msg.pushInfo);
        switch (msg.type) {
            case 'video':
            case 'file':
            case 'image':
            case 'audio':
                return __assign(__assign({}, msg), { body: msg.text || '', attach: msg.file, status: status, ext: msg.custom, pushInfo: pushInfo });
            case 'geo':
                return __assign(__assign({}, msg), { body: msg.text || '', attach: msg.geo, status: status, ext: msg.custom, pushInfo: pushInfo });
            case 'robot':
            case 'custom': {
                var attach = void 0;
                try {
                    attach = JSON.parse(msg.content || '');
                }
                catch (error) {
                    attach = {};
                }
                return __assign(__assign({}, msg), { body: msg.text || '', attach: attach, status: status, ext: msg.custom, pushInfo: pushInfo });
            }
            case 'tip':
                return __assign(__assign({}, msg), { body: msg.tip || '', status: status, ext: msg.custom, pushInfo: pushInfo });
            case 'text':
                return __assign(__assign({}, msg), { body: msg.text || '', status: status, ext: msg.custom, pushInfo: pushInfo });
            case 'notification': {
                if ((_a = msg.attach) === null || _a === void 0 ? void 0 : _a.team) {
                    msg.attach.team = this._formatTeam1to2(msg.attach.team);
                }
                var attach = msg.attach;
                if (attach === null || attach === void 0 ? void 0 : attach.team) {
                    attach.team = this._formatTeam1to2(attach.team);
                }
                return __assign(__assign({}, msg), { attach: attach, status: status, ext: msg.custom, pushInfo: pushInfo });
            }
            case 'g2':
            default:
                return __assign(__assign({}, msg), { status: status, ext: msg.custom, pushInfo: pushInfo });
        }
    };
    NimKitCore.prototype._formatMsg2to1 = function (msg) {
        var status = this._formatMsgStatus2to1(msg.status);
        switch (msg.type) {
            case 'video':
            case 'file':
            case 'image':
            case 'audio':
                return __assign(__assign({}, msg), { text: msg.body || '', file: msg.attach, status: status, custom: msg.ext });
            case 'geo':
                return __assign(__assign({}, msg), { text: msg.body || '', geo: msg.attach, status: status, custom: msg.ext });
            case 'robot':
            case 'custom': {
                var content = void 0;
                try {
                    content = JSON.stringify(msg.attach || '');
                }
                catch (error) {
                    content = '';
                }
                return __assign(__assign({}, msg), { text: msg.body || '', content: content, status: status, custom: msg.ext });
            }
            case 'tip':
                return __assign(__assign({}, msg), { tip: msg.body || '', status: status, custom: msg.ext });
            case 'text':
                return __assign(__assign({}, msg), { text: msg.body || '', status: status, custom: msg.ext });
            // TODO 兼容这两种消息类型
            case 'g2':
            case 'notification':
            default:
                return __assign(__assign({}, msg), { status: status, custom: msg.ext });
        }
    };
    NimKitCore.prototype._formatTeam1to2 = function (team) {
        return filterEmptyKey(__assign(__assign({}, team), { ext: team.custom, serverExt: team.serverCustom, updateExtMode: team.updateCustomMode }));
    };
    NimKitCore.prototype._formatTeamMember1to2 = function (member) {
        return __assign(__assign({}, member), { bitConfigMask: member.muteNotiType
                ? Number(member.muteNotiType)
                : undefined, ext: member.custom });
    };
    NimKitCore.prototype._formatPushInfo1to2 = function (pushInfo) {
        var _a, _b, _c, _d;
        if (!pushInfo) {
            return;
        }
        return {
            needForcePush: (_a = pushInfo.apns) === null || _a === void 0 ? void 0 : _a.forcePush,
            needPush: pushInfo.isPushable,
            needPushNick: pushInfo.needPushNick,
            pushContent: pushInfo.pushContent,
            pushPayload: pushInfo.pushPayload,
            forcePushContent: (_b = pushInfo.apns) === null || _b === void 0 ? void 0 : _b.content,
            forcePushIDsList: ((_c = pushInfo.apns) === null || _c === void 0 ? void 0 : _c.accounts)
                ? JSON.stringify((_d = pushInfo.apns) === null || _d === void 0 ? void 0 : _d.accounts)
                : void 0,
            needPushBadge: pushInfo.isUnreadable,
        };
    };
    NimKitCore.prototype._formatPushInfo2to1 = function (pushInfo) {
        if (!pushInfo) {
            return;
        }
        var accounts;
        try {
            accounts = JSON.parse(pushInfo.forcePushIDsList || '');
        }
        catch (error) {
            accounts = [];
        }
        return {
            needPushNick: pushInfo.needPushNick,
            isPushable: pushInfo.needPush,
            isUnreadable: pushInfo.needPushBadge,
            pushContent: pushInfo.pushContent,
            pushPayload: pushInfo.pushPayload,
            apns: {
                accounts: accounts,
                content: pushInfo.forcePushContent,
                forcePush: pushInfo.needForcePush,
            },
        };
    };
    NimKitCore.prototype._sendTextMsg = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var _a;
            var body = options.body, ext = options.ext, onSendBefore = options.onSendBefore;
            var pushInfo = _this._formatPushInfo2to1(options.pushInfo);
            var msg = _this.nim.sendText(__assign(__assign(__assign({}, options), pushInfo), { text: body, custom: ext, needMsgReceipt: ((_a = options.teamSpecializationInfo) === null || _a === void 0 ? void 0 : _a.needACK) || false, done: function (error, msg) {
                    var newMsg = _this._formatMsg1to2(msg);
                    if (error) {
                        return reject(__assign(__assign({}, error), { msg: newMsg }));
                    }
                    resolve(newMsg);
                } }));
            var newMsg = _this._formatMsg1to2(msg);
            onSendBefore === null || onSendBefore === void 0 ? void 0 : onSendBefore(newMsg);
        });
    };
    NimKitCore.prototype._sendCustomMsg = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var _a;
            var body = options.body, attach = options.attach, ext = options.ext, onSendBefore = options.onSendBefore;
            var pushInfo = _this._formatPushInfo2to1(options.pushInfo);
            var msg = _this.nim.sendCustomMsg(__assign(__assign(__assign({}, options), pushInfo), { text: body, content: attach, custom: ext, needMsgReceipt: ((_a = options.teamSpecializationInfo) === null || _a === void 0 ? void 0 : _a.needACK) || false, done: function (error, msg) {
                    var newMsg = _this._formatMsg1to2(msg);
                    if (error) {
                        return reject(__assign(__assign({}, error), { msg: newMsg }));
                    }
                    resolve(newMsg);
                } }));
            var newMsg = _this._formatMsg1to2(msg);
            onSendBefore === null || onSendBefore === void 0 ? void 0 : onSendBefore(newMsg);
        });
    };
    NimKitCore.prototype._sendFileMsg = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var _a;
            var body = options.body, ext = options.ext, file = options.file, resend = options.resend, attach = options.attach, onSendBefore = options.onSendBefore, onUploadDone = options.onUploadDone, onUploadProgress = options.onUploadProgress, onUploadStart = options.onUploadStart;
            var pushInfo = _this._formatPushInfo2to1(options.pushInfo);
            var resendInfo = resend
                ? { file: attach }
                : { file: undefined, blob: file };
            _this.nim.sendFile(__assign(__assign(__assign(__assign(__assign({}, options), pushInfo), { text: body, custom: ext }), resendInfo), { needMsgReceipt: ((_a = options.teamSpecializationInfo) === null || _a === void 0 ? void 0 : _a.needACK) || false, beginupload: onUploadStart, uploadprogress: onUploadProgress, beforesend: function (msg) {
                    var newMsg = _this._formatMsg1to2(msg);
                    onSendBefore === null || onSendBefore === void 0 ? void 0 : onSendBefore(newMsg);
                }, uploaddone: function (error, file) {
                    if (error) {
                        var rawError = {
                            errCode: '',
                        };
                        rawError.errCode = error.code === 'abort' ? 10499 : error.code;
                        return reject(__assign(__assign({}, error), { rawError: rawError, name: 'uploadError' }));
                    }
                    onUploadDone === null || onUploadDone === void 0 ? void 0 : onUploadDone(file);
                }, done: function (error, msg) {
                    var newMsg = _this._formatMsg1to2(msg);
                    if (error) {
                        return reject(__assign(__assign({}, error), { msg: newMsg }));
                    }
                    resolve(newMsg);
                } }));
        });
    };
    NimKitCore.prototype._connect = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.nim.connect()];
            });
        });
    };
    NimKitCore.prototype._disconnect = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.nim.disconnect()];
            });
        });
    };
    NimKitCore.prototype._destroy = function () {
        var _this = this;
        return new Promise(function (resolve) {
            _this.nim.destroy({
                done: function () {
                    resolve();
                },
            });
        });
    };
    NimKitCore.prototype._resetSessionUnreadCount = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.nim.resetSessionUnread(options.id, function (err) {
                if (err) {
                    reject(err);
                }
                else {
                    resolve();
                }
            });
        });
    };
    NimKitCore.prototype._addFriend = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.nim.addFriend(__assign(__assign({}, options), { done: function (err, obj) {
                    if (err) {
                        reject(err);
                    }
                    else {
                        resolve(obj.friend);
                    }
                } }));
        });
    };
    NimKitCore.prototype._deleteFriend = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.nim.deleteFriend(__assign(__assign({}, options), { done: function (err) {
                    if (err) {
                        reject(err);
                    }
                    else {
                        resolve();
                    }
                } }));
        });
    };
    NimKitCore.prototype._setBlack = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.nim.markInBlacklist(__assign(__assign({}, options), { done: function (err) {
                    if (err) {
                        reject(err);
                    }
                    else {
                        resolve();
                    }
                } }));
        });
    };
    NimKitCore.prototype._deleteSession = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            // TODO SDK 删除 session 有bug，行为与 IM2 deleteSession 不一致，升级 SDK 后看看
            _this.nim.deleteLocalSession({
                id: options.id,
                isDeleteRoaming: options.isSyncToServer,
                isLogic: true,
                done: function (err) {
                    if (err) {
                        reject(err);
                    }
                    else {
                        resolve();
                    }
                },
            });
        });
    };
    NimKitCore.prototype._setMute = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.nim.markInMutelist(__assign(__assign({}, options), { done: function (err) {
                    if (err) {
                        reject(err);
                    }
                    else {
                        resolve();
                    }
                } }));
        });
    };
    NimKitCore.prototype._createTeam = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var _options = __assign(__assign({}, options), { custom: options.ext || '', updateCustomMode: options.updateExtMode || '' });
            _this.nim.createTeam(__assign(__assign({}, _options), { done: function (error, obj) {
                    if (error) {
                        reject(error);
                    }
                    else {
                        resolve(_this._formatTeam1to2(obj.team));
                    }
                } }));
        });
    };
    NimKitCore.prototype._getTeamInfo = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.nim.getTeam(__assign(__assign({}, options), { done: function (error, team) {
                    if (error) {
                        reject(error);
                    }
                    else {
                        resolve(_this._formatTeam1to2(team));
                    }
                } }));
        });
    };
    NimKitCore.prototype._applyTeam = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.nim.applyTeam(__assign(__assign({}, options), { done: function (error, team) {
                    if (error) {
                        reject(error);
                    }
                    else {
                        resolve(_this._formatTeam1to2(team));
                    }
                } }));
        });
    };
    NimKitCore.prototype._addTeamMembers = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.nim.addTeamMembers(__assign(__assign({}, options), { custom: options.ext, done: function (error, obj) {
                    if (error) {
                        reject(error);
                    }
                    else {
                        resolve();
                    }
                } }));
        });
    };
    NimKitCore.prototype._removeTeamMembers = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.nim.removeTeamMembers(__assign(__assign({}, options), { done: function (error) {
                    if (error) {
                        return reject(error);
                    }
                    resolve();
                } }));
        });
    };
    NimKitCore.prototype._updateTeamInfo = function (options) {
        var _this = this;
        var ext = options.ext, updateExtMode = options.updateExtMode;
        return new Promise(function (resolve, reject) {
            return _this.nim.updateTeam(__assign(__assign({}, options), { custom: ext, updateCustomMode: updateExtMode, done: function (error, team) {
                    if (error) {
                        return reject(error);
                    }
                    resolve(team);
                } }));
        });
    };
    NimKitCore.prototype._muteTeam = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            return _this.nim.muteTeamAll(__assign(__assign({}, options), { done: function (error) {
                    if (error) {
                        return reject(error);
                    }
                    resolve();
                } }));
        });
    };
    NimKitCore.prototype._dismissTeam = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            return _this.nim.dismissTeam(__assign(__assign({}, options), { done: function (error) {
                    if (error) {
                        return reject(error);
                    }
                    resolve();
                } }));
        });
    };
    NimKitCore.prototype._leaveTeam = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            return _this.nim.leaveTeam(__assign(__assign({}, options), { done: function (error) {
                    if (error) {
                        return reject(error);
                    }
                    resolve();
                } }));
        });
    };
    NimKitCore.prototype._recallMsg = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.nim.recallMsg(__assign(__assign({}, options), { msg: _this._formatMsg2to1(options.msg), done: function (error) {
                    if (error) {
                        return reject(error);
                    }
                    resolve(options.msg);
                } }));
        });
    };
    NimKitCore.prototype._sendMsgReceipt = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.nim.sendMsgReceipt(__assign(__assign({}, options), { msg: _this._formatMsg2to1(options.msg), done: function (err) {
                    if (err) {
                        reject(err);
                    }
                    else {
                        resolve();
                    }
                } }));
        });
    };
    NimKitCore.prototype._sendTeamMsgReceipt = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.nim.sendTeamMsgReceipt(__assign(__assign({}, options), { done: function (err) {
                    if (err) {
                        reject(err);
                    }
                    else {
                        resolve();
                    }
                } }));
        });
    };
    NimKitCore.prototype._deleteSelfMsgs = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var msgs = options.msgs;
            var msg = msgs[0];
            var from = msg.from, to = msg.to, idClient = msg.idClient, scene = msg.scene, time = msg.time, _a = msg.idServer, idServer = _a === void 0 ? '' : _a;
            _this.nim.deleteMsgSelf({
                msg: msg,
                done: function (error) {
                    if (error) {
                        return reject(error);
                    }
                    resolve([
                        {
                            deletedTime: Date.now(),
                            from: from,
                            idClient: idClient,
                            idServer: idServer,
                            scene: scene,
                            time: time,
                            to: to,
                        },
                    ]);
                },
            });
        });
    };
    NimKitCore.prototype._getHistoryMsgs = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.nim.getHistoryMsgs(__assign(__assign({}, options), { done: function (err, obj) {
                    if (err) {
                        reject(err);
                    }
                    else {
                        var msgs = (obj.msgs || []).map(_this._formatMsg1to2.bind(_this));
                        resolve(msgs);
                    }
                } }));
        });
    };
    NimKitCore.getInstance = function (options) {
        if (!this.ins) {
            this.ins = new NimKitCore(options);
        }
        return this.ins;
    };
    __decorate([
        loggerDec$1
    ], NimKitCore.prototype, "connect", null);
    __decorate([
        loggerDec$1
    ], NimKitCore.prototype, "disconnect", null);
    __decorate([
        loggerDec$1
    ], NimKitCore.prototype, "destroy", null);
    __decorate([
        loggerDec$1
    ], NimKitCore.prototype, "saveMyUserInfo", null);
    __decorate([
        loggerDec$1
    ], NimKitCore.prototype, "getMsgsByIdServer", null);
    __decorate([
        loggerDec$1
    ], NimKitCore.prototype, "getTeamMembers", null);
    __decorate([
        loggerDec$1
    ], NimKitCore.prototype, "isSessionExist", null);
    __decorate([
        loggerDec$1
    ], NimKitCore.prototype, "resetSessionUnreadCount", null);
    __decorate([
        loggerDec$1
    ], NimKitCore.prototype, "addFriend", null);
    __decorate([
        loggerDec$1
    ], NimKitCore.prototype, "applyFriend", null);
    __decorate([
        loggerDec$1
    ], NimKitCore.prototype, "deleteFriend", null);
    __decorate([
        loggerDec$1
    ], NimKitCore.prototype, "updateFriend", null);
    __decorate([
        loggerDec$1
    ], NimKitCore.prototype, "setBlack", null);
    __decorate([
        loggerDec$1
    ], NimKitCore.prototype, "deleteSession", null);
    __decorate([
        loggerDec$1
    ], NimKitCore.prototype, "setMute", null);
    __decorate([
        loggerDec$1
    ], NimKitCore.prototype, "createTeam", null);
    __decorate([
        loggerDec$1
    ], NimKitCore.prototype, "getUsersNameCardFromServer", null);
    __decorate([
        loggerDec$1
    ], NimKitCore.prototype, "getTeamInfo", null);
    __decorate([
        loggerDec$1
    ], NimKitCore.prototype, "applyTeam", null);
    __decorate([
        loggerDec$1
    ], NimKitCore.prototype, "addTeamMembers", null);
    __decorate([
        loggerDec$1
    ], NimKitCore.prototype, "removeTeamMembers", null);
    __decorate([
        loggerDec$1
    ], NimKitCore.prototype, "updateTeamInfo", null);
    __decorate([
        loggerDec$1
    ], NimKitCore.prototype, "muteTeam", null);
    __decorate([
        loggerDec$1
    ], NimKitCore.prototype, "dismissTeam", null);
    __decorate([
        loggerDec$1
    ], NimKitCore.prototype, "transferTeam", null);
    __decorate([
        loggerDec$1
    ], NimKitCore.prototype, "leaveTeam", null);
    __decorate([
        loggerDec$1
    ], NimKitCore.prototype, "sendTextMsg", null);
    __decorate([
        loggerDec$1
    ], NimKitCore.prototype, "sendCustomMsg", null);
    __decorate([
        loggerDec$1
    ], NimKitCore.prototype, "sendImageMsg", null);
    __decorate([
        loggerDec$1
    ], NimKitCore.prototype, "sendFileMsg", null);
    __decorate([
        loggerDec$1
    ], NimKitCore.prototype, "sendVideoMsg", null);
    __decorate([
        loggerDec$1
    ], NimKitCore.prototype, "sendAudioMsg", null);
    __decorate([
        loggerDec$1
    ], NimKitCore.prototype, "resendMsg", null);
    __decorate([
        loggerDec$1
    ], NimKitCore.prototype, "recallMsg", null);
    __decorate([
        loggerDec$1
    ], NimKitCore.prototype, "sendMsgReceipt", null);
    __decorate([
        loggerDec$1
    ], NimKitCore.prototype, "sendTeamMsgReceipt", null);
    __decorate([
        loggerDec$1
    ], NimKitCore.prototype, "clearHistoryMsgsFromServer", null);
    __decorate([
        loggerDec$1
    ], NimKitCore.prototype, "getTeamMsgReads", null);
    __decorate([
        loggerDec$1
    ], NimKitCore.prototype, "deleteSelfMsgs", null);
    __decorate([
        loggerDec$1
    ], NimKitCore.prototype, "getHistoryMsgs", null);
    __decorate([
        loggerDec$1
    ], NimKitCore.prototype, "passFriendApply", null);
    __decorate([
        loggerDec$1
    ], NimKitCore.prototype, "rejectFriendApply", null);
    __decorate([
        loggerDec$1
    ], NimKitCore.prototype, "passTeamApply", null);
    __decorate([
        loggerDec$1
    ], NimKitCore.prototype, "rejectTeamApply", null);
    __decorate([
        loggerDec$1
    ], NimKitCore.prototype, "acceptTeamInvite", null);
    __decorate([
        loggerDec$1
    ], NimKitCore.prototype, "rejectTeamInvite", null);
    __decorate([
        loggerDec$1
    ], NimKitCore.prototype, "addStickTopSession", null);
    __decorate([
        loggerDec$1
    ], NimKitCore.prototype, "deleteStickTopSession", null);
    __decorate([
        loggerDec$1
    ], NimKitCore.prototype, "updateMyMemberInfo", null);
    __decorate([
        loggerDec$1
    ], NimKitCore.prototype, "addTeamManagers", null);
    __decorate([
        loggerDec$1
    ], NimKitCore.prototype, "removeTeamManagers", null);
    __decorate([
        loggerDec$1
    ], NimKitCore.prototype, "forwardMsg", null);
    __decorate([
        loggerDec$1
    ], NimKitCore.prototype, "subscribeEvent", null);
    return NimKitCore;
}());

var name = "nim-web-sdk-ng";
var version = "0.17.0";
var sdk = {
	version: 91400,
	versionFormat: "0.17.0"
};
var description = "Yunxin IM SDK next generation";
var main = "./dist/NIM_BROWSER_SDK.js";
var types$3 = "./dist/NIM_BROWSER_SDK/index.d.ts";
var scripts = {
	prepare: "husky install",
	test: "jest --maxWorkers 1",
	lint: "npx eslint ./src",
	dev: "cd pages/ && npm run dev",
	clean: "rm -rf ./dist",
	emitTypes: "tsc --emitDeclarationOnly",
	build: "npm run clean && npm run emitTypes && rollup --config ./build/rollup.config.js",
	"pages:build": "cd pages/ && npm install && npm run build && cp -rf dist/ ../dist/",
	api: "npm run translate && npm run build:api",
	translate: "rm -rf ./apidocs && multilingual-tool convert --indir=src/typings --outdir=apidocs --includes=ts",
	"build:api": "typedoc --name Chatroom --tsconfig ./typedocChatroom.cn.json && typedoc --name Chatroom --tsconfig ./typedocChatroom.en.json && typedoc --name NIM --tsconfig ./typedocNIM.cn.json && typedoc --name NIM --tsconfig ./typedocNIM.en.json && typedoc --name QChat --tsconfig ./typedocQChat.cn.json && typedoc --name QChat --tsconfig ./typedocQChat.en.json",
	"api-diff": "multilingual-tool diff --dir=src/typings --receiver=3070898 --exclude=DS_Store",
	updateVerInNdp: "node ./script/updateVerInNdp.js"
};
var repository = {
	type: "git",
	url: "ssh://git@g.hz.netease.com:22222/yunxin/im/sdk.git"
};
var keywords = [
	"im",
	"sdk"
];
var author = "yunxin";
var license = "ISC";
var eslintIgnore = [
	"dist/"
];
var files = [
	"README.md",
	"CHANGELOG.md",
	"dist/esm/",
	"dist/CHATROOM*",
	"dist/NIM*",
	"dist/QCHAT*"
];
var devDependencies = {
	"@babel/core": "^7.13.15",
	"@babel/plugin-proposal-class-properties": "^7.13.0",
	"@babel/plugin-transform-runtime": "^7.13.15",
	"@babel/preset-env": "^7.13.15",
	"@babel/preset-typescript": "^7.13.0",
	"@babel/runtime": "^7.13.10",
	"@babel/runtime-corejs3": "^7.13.10",
	"@microsoft/api-extractor": "^7.19.4",
	"@rollup/plugin-babel": "^5.3.0",
	"@rollup/plugin-commonjs": "^18.0.0",
	"@rollup/plugin-json": "^4.1.0",
	"@rollup/plugin-node-resolve": "^11.2.1",
	"@rollup/plugin-replace": "^3.0.0",
	"@rollup/plugin-typescript": "^8.3.0",
	"@types/backo2": "^1.0.1",
	"@types/jest": "^27.4.1",
	"@types/lodash": "^4.14.177",
	"@types/platform": "^1.3.3",
	"@typescript-eslint/eslint-plugin": "^5.12.0",
	"@typescript-eslint/parser": "^5.12.0",
	"@yxfe/multilingual-tool": "^1.0.30",
	"@yxfe/nim-log-reporter": "^0.1.21",
	"@yxfe/nos-uploader": "^1.0.18",
	"@yxfe/request": "^0.2.12",
	backo2: "^1.0.2",
	"core-js": "^3.10.1",
	"cross-env": "^7.0.3",
	eslint: "^8.9.0",
	"eslint-config-prettier": "^8.5.0",
	"eslint-plugin-prettier": "^4.0.0",
	eventemitter3: "^4.0.7",
	husky: "^7.0.4",
	jest: "^27.5.1",
	"lodash-es": "^4.17.21",
	"neroom-web-sdk": "1.7.0",
	platform: "^1.3.6",
	"pre-commit": "^1.2.2",
	prettier: "^2.6.1",
	rollup: "^2.45.2",
	"rollup-plugin-analyzer": "^4.0.0",
	"rollup-plugin-banner": "^0.2.1",
	"rollup-plugin-banner2": "^1.2.2",
	"rollup-plugin-copy": "^3.4.0",
	"rollup-plugin-insert": "^1.3.2",
	"rollup-plugin-terser": "^7.0.2",
	"ts-jest": "^27.1.4",
	tslib: "^2.3.1",
	typedoc: "^0.22.11",
	typescript: "^4.5.4"
};
var imPackageJson = {
	name: name,
	version: version,
	sdk: sdk,
	description: description,
	main: main,
	types: types$3,
	scripts: scripts,
	repository: repository,
	keywords: keywords,
	author: author,
	license: license,
	eslintIgnore: eslintIgnore,
	files: files,
	devDependencies: devDependencies
};

var logger = logDebug({
    level: 'debug',
    appName: packageJson.name,
    version: packageJson.version,
});
var loggerDec = createLoggerDecorator('nim-kit-core-2', logger);
var NimKitCore = /** @class */ (function () {
    function NimKitCore(_a) {
        var initOptions = _a.initOptions, _b = _a.otherOptions, otherOptions = _b === void 0 ? {} : _b, _c = _a.platform, platform = _c === void 0 ? 'Web' : _c;
        var _this = this;
        this.version = imPackageJson.version;
        this.initOptions = initOptions;
        this.otherOptions = otherOptions;
        this.platform = platform;
        this.nim = new NIM$1(initOptions, __assign(__assign({}, otherOptions), { 
            // @ts-ignore 忽略通知类消息
            sessionConfig: __assign(__assign({}, otherOptions.sessionConfig), { unreadCountFilterFn: function (msg) {
                    if (msg.type === 'notification') {
                        return false;
                    }
                    return true;
                } }), syncOptions: __assign(__assign({}, otherOptions.syncOptions), { stickTopSessions: true }) }));
        // 埋点上报
        var reportComponents = [
            'ContactKit',
            'ConversationKit',
            'ChatKit',
            'SearchKit',
        ];
        reportComponents.forEach(function (item) {
            var eventTracking = new EventTracking({
                appKey: _this.initOptions.appkey,
                version: '9.3.1',
                component: item,
                imVersion: _this.version,
                platform: _this.platform,
            });
            eventTracking.track('init', '');
        });
        this._getTeams = frequencyControl(this._getTeams, 1000);
        this._getMuteList = frequencyControl(this._getMuteList, 1000);
        this._getBlackList = frequencyControl(this._getBlackList, 1000);
        this._getFriends = frequencyControl(this._getFriends, 1000);
    }
    Object.defineProperty(NimKitCore.prototype, "connectState", {
        get: function () {
            var statusMap = {
                unconnected: 'idle',
                connecting: 'connecting',
                connected: 'connected',
                logined: 'connected',
                waitReconnect: 'connecting',
                destroyed: 'disconnected',
            };
            //@ts-ignore
            return statusMap[this.nim.status] || 'idle';
        },
        enumerable: false,
        configurable: true
    });
    NimKitCore.prototype.getNIM = function () {
        return this.nim;
    };
    // @loggerDec
    // public async getSessionList(
    //   options: GetSessionsOptions
    // ): Promise<ISession[]> {
    //   const [sessions, muteList, teams] = await Promise.all([
    //     this._getSessions(options),
    //     this._getMuteList(),
    //     this._getTeams(),
    //   ])
    //   const p2pAccids = sessions
    //     .filter((item) => item.scene === 'p2p')
    //     .map((item) => item.to)
    //   const userCards = await this._getUsersNameCardFromServer({
    //     accounts: p2pAccids,
    //   })
    //   return sessions.map((session) => {
    //     if (session.scene === 'p2p') {
    //       const card = userCards.find((item) => item.account === session.to)!
    //       const isMute = muteList.some((item) => item.account === session.to)
    //       return {
    //         ...session,
    //         ...card,
    //         isMute,
    //         // 这里以session的updateTime为准
    //         updateTime: session.updateTime,
    //       }
    //     } else {
    //       const team = teams.find((item) => item.teamId === session.to)
    //       return {
    //         ...session,
    //         ...team,
    //         // 这里以session的updateTime为准
    //         updateTime: session.updateTime,
    //       } as TeamSession
    //     }
    //   })
    // }
    // @loggerDec
    // public async getSession(params: SessionIdOptions): Promise<ISession> {
    //   const session = this._getSession(params)
    //   if (!session) {
    //     throw Error('session 不存在')
    //   }
    //   if (session.scene === 'p2p') {
    //     const [userInfos, muteList] = await Promise.all([
    //       this._getUsersNameCardFromServer({
    //         accounts: [session.to],
    //       }),
    //       this._getMuteList(),
    //     ])
    //     const isMute = muteList.some((item) => item.account === session.to)
    //     return {
    //       ...session,
    //       ...userInfos[0],
    //       isMute,
    //       updateTime: session.updateTime,
    //     }
    //   } else {
    //     const teams = await this._getTeams()
    //     const team = teams.find((item) => item.teamId === session.to)!
    //     return {
    //       ...session,
    //       ...team,
    //       updateTime: session.updateTime,
    //     }
    //   }
    // }
    NimKitCore.prototype.saveMyUserInfo = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var uploadResult, error_1, updateParams, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!((params.file || params.filePath) && params.type)) return [3 /*break*/, 4];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._uploadFile({
                                file: params.file,
                                type: params.type,
                                filePath: params.filePath,
                            })];
                    case 2:
                        uploadResult = _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        logger.error('uploadFile error: ', error_1);
                        logger.warn('去除头像信息继续保存用户信息');
                        return [3 /*break*/, 4];
                    case 4:
                        updateParams = {
                            nick: params.nick,
                            signature: params.signature,
                            avatar: uploadResult ? uploadResult.url : params.avatar,
                            gender: params.gender,
                            email: params.email,
                            birth: params.birth,
                            tel: params.tel,
                            ext: params.ext,
                        };
                        return [4 /*yield*/, this._updateMyNameCard(updateParams)];
                    case 5:
                        res = _a.sent();
                        return [2 /*return*/, res];
                }
            });
        });
    };
    // @loggerDec
    // public async getBlackList(): Promise<IBlackInfo[]> {
    //   const blackList = await this._getBlackList()
    //   const userCards = await this._getUsersNameCardFromServer({
    //     accounts: blackList.map((item) => item.account),
    //   })
    //   return blackList.map((black) => {
    //     const card = userCards.find((item) => item.account === black.account)
    //     return {
    //       ...black,
    //       ...card,
    //     }
    //   })
    // }
    // @loggerDec
    // public async getFriendList(): Promise<IFriendInfo[]> {
    //   const friends = await this._getFriends()
    //   const userCards = await this._getUsersNameCardFromServer({
    //     accounts: friends.map((item) => item.account),
    //   })
    //   return friends.map((friend) => {
    //     const card = userCards.find((item) => item.account === friend.account)
    //     return {
    //       ...friend,
    //       ...card,
    //     }
    //   })
    // }
    // @loggerDec
    // public async getBlackInfos(options: {
    //   accounts: string[]
    // }): Promise<IBlackInfo[]> {
    //   return (await this.getBlackList()).filter((item) =>
    //     options.accounts.includes(item.account)
    //   )
    // }
    // @loggerDec
    // public async getFriendInfos(options: {
    //   accounts: string[]
    // }): Promise<IFriendInfo[]> {
    //   return (await this.getFriendList()).filter((item) =>
    //     options.accounts.includes(item.account)
    //   )
    // }
    NimKitCore.prototype.getMsgsByIdServer = function (params) {
        return this.nim.msgExtend.getMsgsByIdServer(params);
    };
    NimKitCore.prototype.getTeamMembers = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this._getTeamMembers(params)];
            });
        });
    };
    NimKitCore.prototype.isSessionExist = function (sessionId) {
        return __awaiter(this, void 0, void 0, function () {
            var session;
            return __generator(this, function (_a) {
                session = this._getSession({
                    id: sessionId,
                });
                return [2 /*return*/, !!session && session.lastMsg !== void 0];
            });
        });
    };
    NimKitCore.prototype.resetSessionUnreadCount = function (options) {
        return this._resetSessionUnreadCount(options);
    };
    NimKitCore.prototype.addFriend = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this._addFriend(options)];
            });
        });
    };
    NimKitCore.prototype.applyFriend = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.nim.friend.applyFriend(options)];
            });
        });
    };
    NimKitCore.prototype.deleteFriend = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this._deleteFriend(options)];
            });
        });
    };
    NimKitCore.prototype.updateFriend = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.nim.friend.updateFriend(options)];
            });
        });
    };
    NimKitCore.prototype.setBlack = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this._setBlack(options)];
            });
        });
    };
    NimKitCore.prototype.deleteSession = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this._deleteSession(options)];
            });
        });
    };
    NimKitCore.prototype.setMute = function (options) {
        return this._setMute(options);
    };
    NimKitCore.prototype.getUsersNameCardFromServer = function (options) {
        return this._getUsersNameCardFromServer(options);
    };
    // @loggerDec
    // public async getFriends(): Promise<FriendProfile[]> {
    //   return this._getFriends()
    // }
    // @loggerDec
    // public async getBlacks(): Promise<MarkedUserInfo[]> {
    //   return this._getBlackList()
    // }
    // @loggerDec
    // public getTeams(): Promise<Team[]> {
    //   return this._getTeams()
    // }
    NimKitCore.prototype.createTeam = function (options) {
        return this._createTeam(options);
    };
    NimKitCore.prototype.getTeamInfo = function (options) {
        return this._getTeamInfo(options);
    };
    NimKitCore.prototype.applyTeam = function (options) {
        return this._applyTeam(options);
    };
    NimKitCore.prototype.addTeamMembers = function (options) {
        return this._addTeamMembers(options);
    };
    NimKitCore.prototype.removeTeamMembers = function (options) {
        return this._removeTeamMembers(options);
    };
    NimKitCore.prototype.updateTeamInfo = function (options) {
        return this._updateTeamInfo(options);
    };
    NimKitCore.prototype.muteTeam = function (options) {
        return this._muteTeam(options);
    };
    NimKitCore.prototype.dismissTeam = function (options) {
        return this._dismissTeam(options);
    };
    NimKitCore.prototype.transferTeam = function (options) {
        return this.nim.team.transferTeam(options);
    };
    NimKitCore.prototype.leaveTeam = function (options) {
        return this._leaveTeam(options);
    };
    NimKitCore.prototype.sendTextMsg = function (options) {
        return this._sendTextMsg(options);
    };
    NimKitCore.prototype.sendImageMsg = function (options) {
        return this._sendImageMsg(options);
    };
    NimKitCore.prototype.sendFileMsg = function (options) {
        return this._sendFileMsg(options);
    };
    NimKitCore.prototype.sendVideoMsg = function (options) {
        return this.nim.msg.sendVideoMsg(options);
    };
    NimKitCore.prototype.sendAudioMsg = function (options) {
        return this.nim.msg.sendAudioMsg(options);
    };
    // @loggerDec
    // public sendTipMsg(options: ISendTipMsgOptions): Promise<IMMessage> {
    //   return this.nim.msg.sendTipMsg(options)
    // }
    NimKitCore.prototype.sendCustomMsg = function (options) {
        return this._sendCustomMsg(options);
    };
    NimKitCore.prototype.sendMsgReceipt = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.nim.msg.sendMsgReceipt(options)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    NimKitCore.prototype.sendTeamMsgReceipt = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.nim.msg.sendTeamMsgReceipt(options)];
            });
        });
    };
    NimKitCore.prototype.clearHistoryMsgsFromServer = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.nim.msgLog.clearHistoryMsgsFromServer(options)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    NimKitCore.prototype.getTeamMsgReads = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // @ts-ignore 这个 SDK 的 ts 定义写的简直忍无可忍
                return [2 /*return*/, this.nim.msg.getTeamMsgReads(options)];
            });
        });
    };
    NimKitCore.prototype.deleteSelfMsgs = function (options) {
        return this._deleteSelfMsgs(options);
    };
    NimKitCore.prototype.getHistoryMsgs = function (options) {
        return this._getHistoryMsgs(options);
    };
    NimKitCore.prototype.resendMsg = function (options) {
        return this._resendMsg(options);
    };
    NimKitCore.prototype.recallMsg = function (options) {
        return this._recallMsg(options);
    };
    NimKitCore.prototype.passFriendApply = function (options) {
        return this.nim.friend.passFriendApply(options);
    };
    NimKitCore.prototype.rejectFriendApply = function (options) {
        return this.nim.friend.rejectFriendApply(options);
    };
    NimKitCore.prototype.passTeamApply = function (options) {
        return this.nim.team.passTeamApply(options);
    };
    NimKitCore.prototype.rejectTeamApply = function (options) {
        return this.nim.team.rejectTeamApply(options);
    };
    NimKitCore.prototype.acceptTeamInvite = function (options) {
        return this.nim.team.acceptTeamInvite(options);
    };
    NimKitCore.prototype.rejectTeamInvite = function (options) {
        return this.nim.team.rejectTeamInvite(options);
    };
    NimKitCore.prototype.addStickTopSession = function (options) {
        return this.nim.session.addStickTopSession(options);
    };
    NimKitCore.prototype.deleteStickTopSession = function (options) {
        return this.nim.session.deleteStickTopSession(options);
    };
    NimKitCore.prototype.updateMyMemberInfo = function (options) {
        return this.nim.team.updateMyMemberInfo(options);
    };
    NimKitCore.prototype.addTeamManagers = function (options) {
        return this.nim.team.addTeamManagers(options);
    };
    NimKitCore.prototype.removeTeamManagers = function (options) {
        return this.nim.team.removeTeamManagers(options);
    };
    NimKitCore.prototype.forwardMsg = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.nim.msg.forwardMsg(options)];
            });
        });
    };
    NimKitCore.prototype.subscribeEvent = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.nim.event.subscribeEvent(options)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    NimKitCore.prototype.connect = function () {
        return this._connect();
    };
    NimKitCore.prototype.disconnect = function () {
        return this._disconnect();
    };
    NimKitCore.prototype.destroy = function () {
        return this._destroy();
    };
    NimKitCore.prototype.on = function (eventName, fn, context) {
        this.nim.on(eventName, fn, context);
        return this;
    };
    NimKitCore.prototype.off = function (eventName, fn, context, once) {
        this.nim.off(eventName, fn, context, once);
        return this;
    };
    NimKitCore.prototype.emit = function (event) {
        var _a;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return (_a = this.nim).emit.apply(_a, __spreadArray([event], __read(args), false));
    };
    NimKitCore.prototype._getTeams = function () {
        return __awaiter(this, void 0, void 0, function () {
            var res, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.nim.team.getTeams()];
                    case 1:
                        res = _a.sent();
                        return [2 /*return*/, res];
                    case 2:
                        error_2 = _a.sent();
                        // 忽略 803 错误，具体原因咨询 sdk
                        if ((error_2 === null || error_2 === void 0 ? void 0 : error_2.code) === 803) {
                            return [2 /*return*/, []];
                        }
                        throw error_2;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    NimKitCore.prototype._getMuteList = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.nim.user.getMuteList()];
                    case 1: return [2 /*return*/, (_a.sent()).filter(function (item) { return !!item.isMuted; })];
                }
            });
        });
    };
    NimKitCore.prototype._getBlackList = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.nim.user.getBlackList()];
                    case 1: return [2 /*return*/, (_a.sent()).filter(function (item) { return !!item.isBlack; })];
                }
            });
        });
    };
    NimKitCore.prototype._getFriends = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.nim.friend.getFriends()];
                    case 1: return [2 /*return*/, (_a.sent()).filter(function (item) { return !!item.valid; })];
                }
            });
        });
    };
    NimKitCore.prototype._addFriend = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.nim.friend.addFriend(options)];
            });
        });
    };
    NimKitCore.prototype._deleteFriend = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.nim.friend.deleteFriend(options)];
            });
        });
    };
    NimKitCore.prototype._setBlack = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.nim.user.setBlack(options)];
            });
        });
    };
    NimKitCore.prototype._setMute = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.nim.user.setMute(options)];
            });
        });
    };
    NimKitCore.prototype._getUsersNameCardFromServer = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!options.accounts || !options.accounts.length) {
                    return [2 /*return*/, []];
                }
                return [2 /*return*/, this.nim.user.getUsersNameCardFromServer(options)];
            });
        });
    };
    NimKitCore.prototype._getSessions = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.nim.session.getSessions(options)];
            });
        });
    };
    NimKitCore.prototype._getSession = function (options) {
        return this.nim.session.getSession(options);
    };
    NimKitCore.prototype._uploadFile = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.nim.cloudStorage.uploadFile(options)];
            });
        });
    };
    NimKitCore.prototype._updateMyNameCard = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.nim.user.updateMyNameCard(options)];
            });
        });
    };
    NimKitCore.prototype._getTeamMembers = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.nim.team.getTeamMembers(options)];
            });
        });
    };
    NimKitCore.prototype._resetSessionUnreadCount = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.nim.session.resetSessionUnreadCount(options)];
            });
        });
    };
    NimKitCore.prototype._deleteSession = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.nim.session.deleteSession(options)];
            });
        });
    };
    NimKitCore.prototype._createTeam = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.nim.team.createTeam(options)];
            });
        });
    };
    NimKitCore.prototype._getTeamInfo = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.nim.team.getTeamInfo(options)];
            });
        });
    };
    NimKitCore.prototype._applyTeam = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.nim.team.applyTeam(options)];
            });
        });
    };
    NimKitCore.prototype._addTeamMembers = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.nim.team.addTeamMembers(options)];
            });
        });
    };
    NimKitCore.prototype._removeTeamMembers = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.nim.team.removeTeamMembers(options)];
            });
        });
    };
    NimKitCore.prototype._updateTeamInfo = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.nim.team.updateTeamInfo(options)];
            });
        });
    };
    NimKitCore.prototype._muteTeam = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.nim.team.muteTeam(options)];
            });
        });
    };
    NimKitCore.prototype._dismissTeam = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.nim.team.dismissTeam(options)];
            });
        });
    };
    NimKitCore.prototype._leaveTeam = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.nim.team.leaveTeam(options)];
            });
        });
    };
    NimKitCore.prototype._sendTextMsg = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.nim.msg.sendTextMsg(options)];
            });
        });
    };
    NimKitCore.prototype._sendImageMsg = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.nim.msg.sendImageMsg(options)];
            });
        });
    };
    NimKitCore.prototype._sendFileMsg = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.nim.msg.sendFileMsg(options)];
            });
        });
    };
    NimKitCore.prototype._sendCustomMsg = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.nim.msg.sendCustomMsg(options)];
            });
        });
    };
    NimKitCore.prototype._deleteSelfMsgs = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.nim.msg.deleteSelfMsgs(options)];
            });
        });
    };
    NimKitCore.prototype._getHistoryMsgs = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.nim.msgLog.getHistoryMsgs(options)];
            });
        });
    };
    NimKitCore.prototype._resendMsg = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.nim.msg.resendMsg(options)];
            });
        });
    };
    NimKitCore.prototype._recallMsg = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.nim.msg.recallMsg(options)];
            });
        });
    };
    NimKitCore.prototype._connect = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.nim.connect()];
            });
        });
    };
    NimKitCore.prototype._disconnect = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.nim.disconnect()];
            });
        });
    };
    NimKitCore.prototype._destroy = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.nim.destroy()];
            });
        });
    };
    NimKitCore.getInstance = function (options) {
        if (!this.ins) {
            this.ins = new NimKitCore(options);
        }
        return this.ins;
    };
    __decorate([
        loggerDec
    ], NimKitCore.prototype, "saveMyUserInfo", null);
    __decorate([
        loggerDec
    ], NimKitCore.prototype, "getMsgsByIdServer", null);
    __decorate([
        loggerDec
    ], NimKitCore.prototype, "getTeamMembers", null);
    __decorate([
        loggerDec
    ], NimKitCore.prototype, "isSessionExist", null);
    __decorate([
        loggerDec
    ], NimKitCore.prototype, "resetSessionUnreadCount", null);
    __decorate([
        loggerDec
    ], NimKitCore.prototype, "addFriend", null);
    __decorate([
        loggerDec
    ], NimKitCore.prototype, "applyFriend", null);
    __decorate([
        loggerDec
    ], NimKitCore.prototype, "deleteFriend", null);
    __decorate([
        loggerDec
    ], NimKitCore.prototype, "updateFriend", null);
    __decorate([
        loggerDec
    ], NimKitCore.prototype, "setBlack", null);
    __decorate([
        loggerDec
    ], NimKitCore.prototype, "deleteSession", null);
    __decorate([
        loggerDec
    ], NimKitCore.prototype, "setMute", null);
    __decorate([
        loggerDec
    ], NimKitCore.prototype, "getUsersNameCardFromServer", null);
    __decorate([
        loggerDec
    ], NimKitCore.prototype, "createTeam", null);
    __decorate([
        loggerDec
    ], NimKitCore.prototype, "getTeamInfo", null);
    __decorate([
        loggerDec
    ], NimKitCore.prototype, "applyTeam", null);
    __decorate([
        loggerDec
    ], NimKitCore.prototype, "addTeamMembers", null);
    __decorate([
        loggerDec
    ], NimKitCore.prototype, "removeTeamMembers", null);
    __decorate([
        loggerDec
    ], NimKitCore.prototype, "updateTeamInfo", null);
    __decorate([
        loggerDec
    ], NimKitCore.prototype, "muteTeam", null);
    __decorate([
        loggerDec
    ], NimKitCore.prototype, "dismissTeam", null);
    __decorate([
        loggerDec
    ], NimKitCore.prototype, "transferTeam", null);
    __decorate([
        loggerDec
    ], NimKitCore.prototype, "leaveTeam", null);
    __decorate([
        loggerDec
    ], NimKitCore.prototype, "sendTextMsg", null);
    __decorate([
        loggerDec
    ], NimKitCore.prototype, "sendImageMsg", null);
    __decorate([
        loggerDec
    ], NimKitCore.prototype, "sendFileMsg", null);
    __decorate([
        loggerDec
    ], NimKitCore.prototype, "sendVideoMsg", null);
    __decorate([
        loggerDec
    ], NimKitCore.prototype, "sendAudioMsg", null);
    __decorate([
        loggerDec
    ], NimKitCore.prototype, "sendCustomMsg", null);
    __decorate([
        loggerDec
    ], NimKitCore.prototype, "sendMsgReceipt", null);
    __decorate([
        loggerDec
    ], NimKitCore.prototype, "sendTeamMsgReceipt", null);
    __decorate([
        loggerDec
    ], NimKitCore.prototype, "clearHistoryMsgsFromServer", null);
    __decorate([
        loggerDec
    ], NimKitCore.prototype, "getTeamMsgReads", null);
    __decorate([
        loggerDec
    ], NimKitCore.prototype, "deleteSelfMsgs", null);
    __decorate([
        loggerDec
    ], NimKitCore.prototype, "getHistoryMsgs", null);
    __decorate([
        loggerDec
    ], NimKitCore.prototype, "resendMsg", null);
    __decorate([
        loggerDec
    ], NimKitCore.prototype, "recallMsg", null);
    __decorate([
        loggerDec
    ], NimKitCore.prototype, "passFriendApply", null);
    __decorate([
        loggerDec
    ], NimKitCore.prototype, "rejectFriendApply", null);
    __decorate([
        loggerDec
    ], NimKitCore.prototype, "passTeamApply", null);
    __decorate([
        loggerDec
    ], NimKitCore.prototype, "rejectTeamApply", null);
    __decorate([
        loggerDec
    ], NimKitCore.prototype, "acceptTeamInvite", null);
    __decorate([
        loggerDec
    ], NimKitCore.prototype, "rejectTeamInvite", null);
    __decorate([
        loggerDec
    ], NimKitCore.prototype, "addStickTopSession", null);
    __decorate([
        loggerDec
    ], NimKitCore.prototype, "deleteStickTopSession", null);
    __decorate([
        loggerDec
    ], NimKitCore.prototype, "updateMyMemberInfo", null);
    __decorate([
        loggerDec
    ], NimKitCore.prototype, "addTeamManagers", null);
    __decorate([
        loggerDec
    ], NimKitCore.prototype, "removeTeamManagers", null);
    __decorate([
        loggerDec
    ], NimKitCore.prototype, "forwardMsg", null);
    __decorate([
        loggerDec
    ], NimKitCore.prototype, "subscribeEvent", null);
    __decorate([
        loggerDec
    ], NimKitCore.prototype, "connect", null);
    __decorate([
        loggerDec
    ], NimKitCore.prototype, "disconnect", null);
    __decorate([
        loggerDec
    ], NimKitCore.prototype, "destroy", null);
    return NimKitCore;
}());

var types$2 = /*#__PURE__*/Object.freeze({
    __proto__: null
});

function NimKitCoreFactory(version) {
    switch (version) {
        case 1:
            return NimKitCore$1;
        case 2:
            return NimKitCore;
        default:
            throw new Error('NimKitCoreFactory: version not found');
    }
}

var ChatroomKitCore$1 = /** @class */ (function () {
    function ChatroomKitCore(options) {
        var _this = this;
        this._options = options;
        this._emitter = new EventEmitter();
        this._options.appkey;
        var defaultCallbackObj = {
            onconnect: function (data) {
                _this._emitter.emit('logined', data);
            },
            ondisconnect: function (err) {
                // @ts-ignore
                _this._emitter.emit('disconnect', err);
            },
            onwillreconnect: function (data) {
                _this._emitter.emit('willReconnect', data);
            },
            onmsgs: function (msgs) {
                if (Array.isArray(msgs)) {
                    msgs = msgs.map(function (msg) {
                        return _this._formatChatroomMsg1to2(msg);
                    });
                }
                else {
                    msgs = _this._formatChatroomMsg1to2(msgs);
                }
                // im2返回的消息结果为单条消息，im1为消息数组
                _this._emitter.emit('chatroomMsg', msgs);
            },
            onTagsUpdate: function (tags) {
                console.log('onTagsUpdate', tags);
                // @ts-ignore
                _this._emitter.emit('tagsUpdate', tags);
            },
            onerror: function (err) {
                console.error('onError', err);
                // @ts-ignore
                _this._emitter.emit('error', err);
            },
        };
        var finalCallbackObj = mergeFuncObj(this._options.callbackOptions, defaultCallbackObj);
        this._chatroom = Chatroom.getInstance(__assign(__assign({}, this._formatInitOptions(this._options)), finalCallbackObj));
    }
    Object.defineProperty(ChatroomKitCore.prototype, "version", {
        get: function () {
            return '1';
        },
        enumerable: false,
        configurable: true
    });
    ChatroomKitCore.prototype.connect = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                // 需要确认是否返回promise
                return [2 /*return*/, this._chatroom.connect()];
            });
        });
    };
    ChatroomKitCore.prototype.disconnect = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                // 目前9.8.0版本interface回调是必传参数
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        _this._chatroom.disconnect({
                            done: function (err, data) {
                                if (err) {
                                    reject(err);
                                }
                                else {
                                    resolve(data);
                                }
                            },
                        });
                    })];
            });
        });
    };
    ChatroomKitCore.prototype.setOptions = function (options) {
        this._options = options;
        this._chatroom &&
            this._chatroom.setOptions(__assign(__assign({}, options), this._formatInitOptions(options)));
    };
    ChatroomKitCore.prototype.destroy = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        if (_this._chatroom) {
                            // @ts-ignore
                            _this._chatroom.destroy({
                                done: function (err) {
                                    if (err) {
                                        reject(err);
                                    }
                                    else {
                                        resolve();
                                    }
                                },
                            });
                        }
                        else {
                            resolve();
                        }
                    })];
            });
        });
    };
    /**
     * 获取聊天室实例
     */
    ChatroomKitCore.prototype.getChatroom = function () {
        return this._chatroom;
    };
    ChatroomKitCore.prototype.sendTextMsg = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            //@ts-ignore
            _this._chatroom.sendText(__assign(__assign({}, options), { text: options.body, custom: options.ext, done: function (err, msg) {
                    if (err) {
                        reject(err);
                    }
                    else {
                        msg = _this._formatChatroomMsg1to2(msg);
                        resolve(msg);
                    }
                } }));
        });
    };
    /**
     * 发送文件消息
     * @param options
     */
    ChatroomKitCore.prototype.sendFileMsg = function (options) {
        throw Error('Method not implemented.');
        // todo 逻辑需要重新梳理
        // return new Promise((resolve, reject) => {
        //   const {
        //     body,
        //     ext,
        //     file,
        //     resend,
        //     attach,
        //     onSendBefore,
        //     onUploadDone,
        //     onUploadProgress,
        //     onUploadStart,
        //   } = options as any //IBaseSendFileOptions目前字段存在问题
        //   const resendInfo = resend
        //     ? { file: attach }
        //     : { file: undefined, blob: file }
        //   this._chatroom.sendFile({
        //     ...options,
        //     custom: ext,
        //     ...resendInfo,
        //     beginupload: onUploadStart,
        //     uploadprogress: onUploadProgress,
        //     beforesend: (msg: NIMChatroomMessage) => {
        //       const newMsg = this._formatChatroomMsg1to2(msg)
        //       onSendBefore?.(newMsg)
        //     },
        //     uploaddone: (error: any, file: any) => {
        //       if (error) {
        //         return reject({
        //           ...error,
        //           name: 'uploadError',
        //         })
        //       }
        //       onUploadDone?.(file)
        //     },
        //     done: (error: any, msg: NIMChatroomMessage) => {
        //       const newMsg = this._formatChatroomMsg1to2(msg)
        //       if (error) {
        //         return reject({
        //           ...error,
        //           msg: newMsg,
        //         })
        //       }
        //       resolve(newMsg)
        //     }
        //   })
        // })
    };
    /**
     * 查询聊天室成员
     * @param options
     */
    ChatroomKitCore.prototype.queryMembers = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var limit = options.limit, time = options.time, type = options.type;
            var typeMap = {
                regular: {
                    guest: false,
                    onlyOnline: false,
                },
                temp: {
                    guest: true,
                    desc: true,
                },
                regularOnline: {
                    guest: false,
                    onlyOnline: true,
                },
                regularReverse: {
                    guest: true,
                    desc: false,
                },
            };
            var tmpOptions = typeMap[type] || {};
            //@ts-ignore
            _this._chatroom.getChatroomMembers(__assign(__assign(__assign({}, options), tmpOptions), { limit: limit, time: time, done: function (err, obj) {
                    if (err) {
                        return reject(err);
                    }
                    resolve(obj.members);
                } }));
        });
    };
    /**
     * 更新自己在聊天室中的信息
     * @param options
     */
    ChatroomKitCore.prototype.updateMyRoomRole = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var tmpOptions = __assign({}, options);
            if (options.member && options.member.ext) {
                tmpOptions.custom = options.member.ext;
            }
            if (options.ext) {
                tmpOptions.custom = options.ext;
            }
            //@ts-ignore
            _this._chatroom.updateMyChatroomMemberInfo(__assign(__assign({}, tmpOptions), { done: function (err, obj) {
                    if (err) {
                        return reject(err);
                    }
                    resolve(obj);
                } }));
        });
    };
    /**
     * 查询历史消息
     * @param options
     */
    ChatroomKitCore.prototype.queryMessageHistory = function (options) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._chatroom.getHistoryMsgs(__assign(__assign({}, options), { done: function (err, obj) {
                    if (err) {
                        reject(err);
                        return;
                    }
                    // this.parseMsgs([...obj.msgs].reverse())
                    var tmpMsgs = [];
                    if (obj.msgs) {
                        tmpMsgs = obj.msgs.map(function (msg) {
                            return _this._formatChatroomMsg1to2(msg);
                        });
                    }
                    resolve(tmpMsgs);
                } }));
        });
    };
    ChatroomKitCore.prototype.emit = function (event) {
        var _a;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return (_a = this._emitter).emit.apply(_a, __spreadArray([event], __read(args), false));
    };
    ChatroomKitCore.prototype.off = function (eventName, fn, context, once) {
        this._emitter.off(eventName, fn, context, once);
        return this;
    };
    ChatroomKitCore.prototype.on = function (eventName, fn, context) {
        this._emitter.on(eventName, fn, context);
        return this;
    };
    ChatroomKitCore.prototype._formatChatroomMsg1to2 = function (msg) {
        var tmpMsg = __assign({}, msg);
        switch (msg.type) {
            case 'video':
            case 'file':
            case 'image':
            case 'audio':
                tmpMsg = __assign(__assign({}, msg), { body: msg.text || '', attach: msg.file, ext: msg.custom });
                break;
            case 'geo':
                tmpMsg = __assign(__assign({}, msg), { body: msg.text || '', attach: msg.geo, ext: msg.custom });
            case 'robot':
            case 'custom': {
                var attach = void 0;
                try {
                    attach = JSON.parse(msg.content || '');
                }
                catch (error) {
                    attach = {};
                }
                tmpMsg = __assign(__assign({}, msg), { body: msg.text || '', attach: attach, ext: msg.custom });
            }
            case 'tip':
                tmpMsg = __assign(__assign({}, msg), { body: msg.tip || '', ext: msg.custom });
            case 'text':
                tmpMsg = __assign(__assign({}, msg), { body: msg.text || '', ext: msg.custom });
            case 'g2':
            case 'notification':
            default:
                tmpMsg = __assign(__assign({}, msg), { ext: msg.custom });
        }
        return __assign(__assign({}, tmpMsg), { fromExt: msg.fromCustom });
    };
    ChatroomKitCore.prototype._formatMsg2to1 = function (msg) {
        var tmpMsg = __assign({}, msg);
        switch (msg.type) {
            case 'video':
            case 'file':
            case 'image':
            case 'geo':
                tmpMsg = __assign(__assign({}, msg), { text: msg.body || '', geo: msg.attach, custom: msg.ext });
                break;
            case 'robot':
            case 'custom': {
                var content = void 0;
                try {
                    content = JSON.stringify(msg.attach || '');
                }
                catch (error) {
                    content = '';
                }
                tmpMsg = __assign(__assign({}, msg), { text: msg.body || '', content: content, custom: msg.ext });
                break;
            }
            case 'tip':
                tmpMsg = __assign(__assign({}, msg), { tip: msg.body || '', custom: msg.ext });
                break;
            case 'text':
                tmpMsg = __assign(__assign({}, msg), { text: msg.body || '', custom: msg.ext });
                break;
            // TODO 兼容这两种消息类型
            case 'g2':
            case 'notification':
            default:
                tmpMsg = __assign(__assign({}, msg), { custom: msg.ext });
        }
        return __assign(__assign({}, tmpMsg), { fromCustom: msg.fromExt });
    };
    ChatroomKitCore.prototype._formatInitOptions = function (options) {
        return __assign(__assign({}, options), { chatroomCustom: options.chatroomExt, appKey: options.appkey, debug: options.debugLevel !== 'off', logLevel: options.debugLevel });
    };
    return ChatroomKitCore;
}());

// import ChatroomSDK from 'nim-web-sdk-ng/dist/CHATROOM_BROWSER_SDK'
var ChatroomKitCore = /** @class */ (function () {
    function ChatroomKitCore() {
    }
    Object.defineProperty(ChatroomKitCore.prototype, "version", {
        get: function () {
            return '2';
        },
        enumerable: false,
        configurable: true
    });
    ChatroomKitCore.prototype.connect = function () {
        return Promise.resolve(undefined);
    };
    ChatroomKitCore.prototype.destroy = function () {
        return Promise.resolve(undefined);
    };
    ChatroomKitCore.prototype.disconnect = function () {
        return Promise.resolve(undefined);
    };
    ChatroomKitCore.prototype.emit = function (event) {
        return false;
    };
    ChatroomKitCore.prototype.getChatroom = function () {
        return;
    };
    ChatroomKitCore.prototype.off = function (eventName, fn, context, once) {
        return this;
    };
    ChatroomKitCore.prototype.on = function (eventName, fn, context) {
        return this;
    };
    ChatroomKitCore.prototype.queryMembers = function (options) {
        return Promise.resolve([]);
    };
    ChatroomKitCore.prototype.queryMessageHistory = function (options) {
        return Promise.resolve([]);
    };
    ChatroomKitCore.prototype.sendFileMsg = function (options) {
        throw Error('Method not implemented.');
    };
    ChatroomKitCore.prototype.sendTextMsg = function (options) {
        throw Error('Method not implemented.');
    };
    ChatroomKitCore.prototype.setOptions = function (options) {
        throw Error('Method not implemented.');
    };
    ChatroomKitCore.prototype.updateMyRoomRole = function (options) {
        throw Error('Method not implemented.');
    };
    return ChatroomKitCore;
}());

var types$1 = /*#__PURE__*/Object.freeze({
    __proto__: null
});

function ChatroomKitCoreFactory(version) {
    switch (version) {
        case 1:
            return ChatroomKitCore$1;
        case 2:
            return ChatroomKitCore;
        default:
            throw new Error('ChatroomKitCoreFactory: version not found');
    }
}

var XKitServiceManager = /** @class */ (function () {
    function XKitServiceManager() {
        this._services = new Map();
    }
    // 注册服务
    XKitServiceManager.prototype.registerService = function (serviceName, service) {
        if (serviceName) {
            return;
        }
        this._services[serviceName] = service;
    };
    // 调用服务
    XKitServiceManager.prototype.callService = function (serviceName, method, param) {
        var _a;
        var service = this._services.get(serviceName);
        if (service) {
            if (service.onMethodCall) {
                return service.onMethodCall(method, param);
            }
            else {
                return (_a = service[method]) === null || _a === void 0 ? void 0 : _a.call(service, param);
            }
        }
        else {
            return null;
        }
    };
    XKitServiceManager.getInstance = function () {
        if (!XKitServiceManager._instance) {
            XKitServiceManager._instance = new XKitServiceManager();
        }
        return XKitServiceManager._instance;
    };
    XKitServiceManager._instance = null;
    return XKitServiceManager;
}());

/*
 * Copyright (c) 2022 NetEase, Inc. All rights reserved.
 * Use of this source code is governed by a MIT license that can be
 * found in the LICENSE file.
 */

var types = /*#__PURE__*/Object.freeze({
    __proto__: null
});

var XKit = /** @class */ (function () {
    function XKit() {
        this._tag = 'XKitCore';
    }
    XKit.prototype.initialize = function (initOptions) {
        var reporterInfoOption = initOptions.reporterInfoOption;
        this.initReporter(reporterInfoOption);
        return this;
    };
    XKit.prototype.registerService = function (service) {
        XKitServiceManager.getInstance().registerService(service.serviceName, service);
    };
    XKit.prototype.callService = function (serviceName, method, param) {
        return XKitServiceManager.getInstance().callService(serviceName, method, param);
    };
    XKit.prototype.initReporter = function (initOptions) {
        var eventTracking = new EventTracking({
            appKey: initOptions.appKey,
            version: initOptions.version,
            nertcVersion: initOptions.nertcVersion,
            imVersion: initOptions.imVersion,
            platform: initOptions.platform,
            component: initOptions.component,
        });
        eventTracking.track('init', '');
    };
    XKit.getInstance = function () {
        if (!XKit.instance) {
            XKit.instance = new XKit();
        }
        return XKit.instance;
    };
    XKit.instance = null;
    return XKit;
}());

export { ChatroomKitCoreFactory, types$1 as ChatroomKitCoreTypes, NimKitCoreFactory, types$2 as NimKitCoreTypes, XKit, XKitServiceManager, types as XKitTypes };
